// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"fYvWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "leftControlDiv", ()=>leftControlDiv);
var _olCss = require("ol/ol.css");
var _styleCss = require("./style.css");
var _ol = require("ol");
var _control = require("ol/control");
var _proj = require("ol/proj");
var _azureLoginControl = require("./controls/AzureLoginControl");
var _monkeyFetch = require("./auth/monkeyFetch");
var _sdolayersAndControls = require("./config/SDOLayersAndControls");
var _latLongControl = require("./config/LatLongControl");
var _boundaryCodesControl = require("./config/BoundaryCodesControl");
var _dateInputControl = require("./config/DateInputControl");
var _heatmapLayersAndControls = require("./config/HeatmapLayersAndControls");
var _geocoderControl = require("./config/GeocoderControl");
var _basemapLayersAndControls = require("./config/BasemapLayersAndControls");
var _wktlayerAndControl = require("./config/WKTLayerAndControl");
var _drawAndControl = require("./config/DrawAndControl");
var _group = require("ol/layer/Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _layersAndControls = require("./config/LayersAndControls");
var _productAndControl = require("./config/ProductAndControl");
var _featureInfoControl = require("./config/FeatureInfoControl");
var _urlstateManager = require("./state/URLStateManager");
const urlView = (0, _urlstateManager.getViewFromURL)();
var view = new (0, _ol.View)({
    center: urlView ? urlView.center : (0, _proj.fromLonLat)([
        7.233208,
        50.3750669
    ]),
    zoom: urlView ? urlView.zoom : 8
});
// monkeypatch fetch to use the flatgeobuf library
(0, _monkeyFetch.configureMonkeyFetch)();
const azureLoginControl = new (0, _azureLoginControl.AzureLoginControl)();
const leftControlDiv = document.createElement("div");
leftControlDiv.id = "controls-left";
const leftControl = new (0, _control.Control)({
    element: leftControlDiv
});
const vectorFeaturesControlDiv = document.createElement("div");
vectorFeaturesControlDiv.className = "vector-feature";
const vectorFeaturesControl = new (0, _control.Control)({
    element: vectorFeaturesControlDiv,
    target: leftControlDiv
});
const map = new (0, _ol.Map)({
    target: "map",
    layers: [],
    view: view,
    controls: (0, _control.defaults)({
        zoom: false,
        attribution: false,
        rotate: false
    }).extend([
        azureLoginControl,
        leftControl
    ])
});
(0, _urlstateManager.registerMap)(map);
const heatmapLayerGroup = new (0, _groupDefault.default)();
(0, _latLongControl.addLatLongControl)(map, view, leftControlDiv);
(0, _boundaryCodesControl.addBoundaryCodesControl)(map, view, leftControlDiv, azureLoginControl);
const dateInputControl = (0, _dateInputControl.addDateInputControl)(map, leftControlDiv);
azureLoginControl.once("propertychange", function() {
    (0, _basemapLayersAndControls.addBasemapLayersAndControls)(map, azureLoginControl);
    const featureInfoControl = (0, _featureInfoControl.addFeatureInfoControl)(map);
    map.addLayer(heatmapLayerGroup);
    (0, _heatmapLayersAndControls.addHeatmapLayersAndControls)(map, azureLoginControl, dateInputControl, leftControlDiv, heatmapLayerGroup, featureInfoControl);
    // SDO
    (0, _sdolayersAndControls.addSDOLayersAndControls)(map, azureLoginControl, dateInputControl, leftControlDiv);
    // vector
    map.addControl(vectorFeaturesControl);
    const wktInputControl = (0, _wktlayerAndControl.addWKTLayerAndControl)(map, leftControlDiv, view, azureLoginControl)[1];
    // Drawing toolbar sits directly above the WKT box (below the layer categories).
    (0, _drawAndControl.addDrawControl)(map, leftControlDiv, wktInputControl);
    (0, _geocoderControl.addGeocoderControl)(map);
    (0, _layersAndControls.addLayersAndControls)(map, azureLoginControl, featureInfoControl, vectorFeaturesControlDiv);
    (0, _productAndControl.addProductControl)(map, vectorFeaturesControlDiv);
    // Start URL state sync after all controls are registered
    (0, _urlstateManager.startSync)();
});

},{"ol/ol.css":"79tvn","./style.css":"15VB6","ol":[["Map","7mjtW","default"],["View","baCdC","default"]],"ol/control":[["Control","8KSMn","default"],["defaults","8Xvbb"]],"ol/proj":"gN0IK","./controls/AzureLoginControl":"hik4h","./auth/monkeyFetch":"7Uw6j","./config/SDOLayersAndControls":"gl3dx","./config/LatLongControl":"76s4u","./config/BoundaryCodesControl":"9IQmt","./config/DateInputControl":"gEHhK","./config/HeatmapLayersAndControls":"2FOUV","./config/GeocoderControl":"6bJVZ","./config/BasemapLayersAndControls":"cLPMT","./config/WKTLayerAndControl":"73XNr","./config/DrawAndControl":"l9yuk","ol/layer/Group":"6DIkJ","./config/LayersAndControls":"jJjT8","./config/ProductAndControl":"kDeFr","./config/FeatureInfoControl":"i6xk4","./state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"79tvn":[function() {},{}],"15VB6":[function() {},{}],"l9yuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create the drawing toolbar and place it directly above the WKT input box
 * (below the layer-category section). The control manages its own
 * ol/interaction/Draw lifecycle via the passed map, so it is positioned in the
 * DOM manually rather than through map.addControl (which would append it to the
 * map viewport instead of the sidebar).
 *
 * @param {import("ol/Map").default} map
 * @param {HTMLElement} target - the sidebar container (#controls-left)
 * @param {import("../controls/WKTInputControl").WKTInputControl} wktInputControl
 * @returns {DrawControl}
 */ parcelHelpers.export(exports, "addDrawControl", ()=>addDrawControl);
var _drawControl = require("../controls/DrawControl");
function addDrawControl(map, target, wktInputControl) {
    const drawControl = new (0, _drawControl.DrawControl)({
        map,
        wktInputControl
    });
    target.insertBefore(drawControl.element, wktInputControl.element);
    return drawControl;
}

},{"../controls/DrawControl":"1QocE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1QocE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Collapsible sidebar toolbar for drawing geometries and placing tiles. On
 * finish, the result is written into the WKT input box, overwriting it; the
 * existing WKT layer renders it. The toolbar is placed in the DOM by
 * addDrawControl (it is not registered via map.addControl).
 */ parcelHelpers.export(exports, "DrawControl", ()=>DrawControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _draw = require("ol/interaction/Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _wkt = require("ol/format/WKT");
var _wktDefault = parcelHelpers.interopDefault(_wkt);
var _lineString = require("ol/geom/LineString");
var _lineStringDefault = parcelHelpers.interopDefault(_lineString);
var _polygon = require("ol/geom/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
var _multiPoint = require("ol/geom/MultiPoint");
var _multiPointDefault = parcelHelpers.interopDefault(_multiPoint);
var _proj = require("ol/proj");
var _style = require("ol/style");
var _drawIcons = require("./drawIcons");
var _mortonTile = require("../util/mortonTile");
// Shape tools. `type` is the ol/interaction/Draw geometry type; `multiVertex`
// flags the click-per-vertex tools (line/polygon) that get the
// Finish / Undo / Cancel action row and Enter/Backspace finishing.
const SHAPE_TOOLS = [
    {
        id: "point",
        type: "Point",
        icon: "point",
        title: "Draw a point"
    },
    {
        id: "line",
        type: "LineString",
        icon: "line",
        title: "Draw a line",
        multiVertex: true
    },
    {
        id: "polygon",
        type: "Polygon",
        icon: "polygon",
        title: "Draw a polygon",
        multiVertex: true
    },
    {
        id: "rectangle",
        type: "Circle",
        icon: "rectangle",
        title: "Draw a rectangle",
        box: true
    }
];
// Tile tools place a single point; on finish the clicked coordinate is turned
// into a tile at the chosen level/resolution. `tile` selects the tile kind.
const TILE_TOOLS = [
    {
        id: "morton",
        type: "Point",
        icon: "morton",
        title: "Place a Morton tile",
        tile: "morton",
        levelLabel: "Level",
        levelMin: 0,
        levelMax: 23,
        levelDefault: 10
    }
];
const ALL_TOOLS = [
    ...SHAPE_TOOLS,
    ...TILE_TOOLS
];
// Initial level-input range/value (Morton); adapts per tile tool on selection.
const DEFAULT_LEVEL = 10;
const DEFAULT_LEVEL_MAX = 23;
// Sketch styling. Committed edges are solid (with a light fill for polygons);
// only the segment to the cursor is dashed — the rubber-band look from wktmap.
// No fill is rasterised over the moving cursor sweep (only the committed area),
// which keeps per-pointermove rendering cheap.
const SKETCH_COLOR = "#3a3a3a";
const SOLID_STROKE = new (0, _style.Stroke)({
    color: SKETCH_COLOR,
    width: 1.5
});
const DASHED_STROKE = new (0, _style.Stroke)({
    color: SKETCH_COLOR,
    width: 1.5,
    lineDash: [
        5,
        5
    ]
});
const COMMITTED_FILL = new (0, _style.Fill)({
    color: "rgba(58, 58, 58, 0.1)"
});
const VERTEX_IMAGE = new (0, _style.Circle)({
    radius: 3,
    fill: new (0, _style.Fill)({
        color: SKETCH_COLOR
    })
});
const VERTEX_STYLE = new (0, _style.Style)({
    image: VERTEX_IMAGE
});
const DASHED_STYLE = new (0, _style.Style)({
    stroke: DASHED_STROKE
});
const BOX_STYLE = [
    new (0, _style.Style)({
        fill: COMMITTED_FILL
    }),
    new (0, _style.Style)({
        stroke: DASHED_STROKE
    })
];
const TILE_PREVIEW_STYLE = new (0, _style.Style)({
    fill: new (0, _style.Fill)({
        color: "rgba(58, 58, 58, 0.12)"
    }),
    stroke: new (0, _style.Stroke)({
        color: "rgba(58, 58, 58, 0.9)",
        width: 2,
        lineDash: [
            6,
            4
        ]
    })
});
const START_HINT = {
    point: "Click on the map to place a point.",
    line: "Click to start drawing a line.",
    polygon: "Click to start drawing a shape.",
    rectangle: "Click and drag to draw a rectangle.",
    morton: "Click on the map to place a Morton tile."
};
const CONTINUE_HINT = {
    line: "Click to add points; double-click or Enter to finish.",
    polygon: "Click to add points; click the first point or Enter to finish."
};
// Round WKT coordinates to 7 decimals (~1 cm) so reprojection float noise
// (e.g. 45.43403509999999) doesn't end up in the box.
function roundWkt(wkt) {
    return wkt.replace(/-?\d+\.\d+/g, (n)=>String(parseFloat(parseFloat(n).toFixed(7))));
}
class DrawControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        // A <details> so the (rarely-used) toolbar collapses out of the way and
        // inherits the same card styling as the layer-category sections.
        const element = document.createElement("details");
        element.className = "draw-toolbar ol-unselectable";
        super({
            element
        });
        this.olMap_ = options.map;
        this.wktControl_ = options.wktInputControl;
        this.wktFormat_ = new (0, _wktDefault.default)();
        // Detached source: the in-progress sketch is rendered by Draw's own overlay;
        // the finished feature lands here, gets serialised, then the source is cleared.
        this.sketchSource_ = new (0, _vectorDefault1.default)();
        this.tilePreviewSource_ = new (0, _vectorDefault1.default)();
        this.tilePreviewLayer_ = new (0, _vectorDefault.default)({
            source: this.tilePreviewSource_,
            style: TILE_PREVIEW_STYLE
        });
        this.tilePreviewLayer_.setZIndex(10000);
        this.activeTool_ = null; // the active ALL_TOOLS entry, or null
        this.draw_ = null; // active ol/interaction/Draw, or null
        this.drawing_ = false; // true between drawstart and drawend/drawabort
        this.toolButtons_ = {}; // tool id -> button element
        this.tileOutput_ = "code"; // "code" | "wkt" — what a tile click writes
        this.tilePreviewActive_ = false;
        this.tilePreviewFeature_ = null;
        this.tilePreviewCode_ = null;
        this.tilePreviewFrame_ = null;
        this.pendingPreviewCoordinate_ = null;
        this.lastPreviewCoordinate_ = null;
        this.onPointerMove_ = this.handlePointerMove_.bind(this);
        this.onPointerLeave_ = this.handlePointerLeave_.bind(this);
        this.onKeyDown_ = this.handleKeyDown_.bind(this);
        this.buildDom_(element);
    }
    buildDom_(root) {
        const summary = document.createElement("summary");
        summary.textContent = "Draw";
        root.appendChild(summary);
        const tools = document.createElement("div");
        tools.className = "draw-toolbar-row draw-tools";
        tools.setAttribute("role", "toolbar");
        tools.setAttribute("aria-label", "Drawing tools");
        SHAPE_TOOLS.forEach((tool)=>tools.appendChild(this.makeToolButton_(tool)));
        root.appendChild(tools);
        this.buildTilesGroup_(root);
        const actions = document.createElement("div");
        actions.className = "draw-actions";
        actions.setAttribute("role", "toolbar");
        actions.setAttribute("aria-label", "Drawing actions");
        actions.hidden = true;
        this.finishBtn_ = this.actionButton_("finish", "Finish", "Finish drawing (Enter)", ()=>this.finish_());
        this.undoBtn_ = this.actionButton_("undo", "Undo", "Delete last point (Backspace)", ()=>this.undo_());
        this.cancelBtn_ = this.actionButton_("cancel", "Cancel", "Cancel drawing (Esc)", ()=>this.cancel_());
        actions.appendChild(this.finishBtn_);
        actions.appendChild(this.undoBtn_);
        actions.appendChild(this.cancelBtn_);
        this.actionsRow_ = actions;
        root.appendChild(actions);
        const status = document.createElement("p");
        status.className = "draw-status";
        status.setAttribute("aria-live", "polite");
        status.hidden = true;
        this.statusEl_ = status;
        root.appendChild(status);
    }
    buildTilesGroup_(root) {
        const tilesLabel = document.createElement("span");
        tilesLabel.className = "draw-tiles-label";
        tilesLabel.textContent = "Tiles";
        root.appendChild(tilesLabel);
        const tilesRow = document.createElement("div");
        tilesRow.className = "draw-toolbar-row draw-tiles";
        tilesRow.setAttribute("role", "toolbar");
        tilesRow.setAttribute("aria-label", "Tile tools");
        TILE_TOOLS.forEach((tool)=>tilesRow.appendChild(this.makeToolButton_(tool)));
        const levelLabel = document.createElement("label");
        levelLabel.className = "draw-level-label";
        const levelText = document.createElement("span");
        levelText.textContent = "Level";
        levelLabel.appendChild(levelText);
        this.levelText_ = levelText;
        const levelInput = document.createElement("input");
        levelInput.type = "number";
        levelInput.className = "draw-level";
        levelInput.min = "0";
        levelInput.max = String(DEFAULT_LEVEL_MAX);
        levelInput.value = String(DEFAULT_LEVEL);
        levelInput.title = `Tile level / resolution`;
        levelInput.addEventListener("input", ()=>this.refreshTilePreview_());
        levelLabel.appendChild(levelInput);
        this.levelInput_ = levelInput;
        tilesRow.appendChild(levelLabel);
        root.appendChild(tilesRow);
        // Output-format toggle (Code | WKT), shared by all tile tools. The WKT box
        // decodes canonical tile codes; this only controls what a tile click writes.
        const outputRow = document.createElement("div");
        outputRow.className = "draw-toolbar-row draw-output";
        outputRow.setAttribute("role", "group");
        outputRow.setAttribute("aria-label", "Tile output format");
        const outLabel = document.createElement("span");
        outLabel.className = "draw-output-label";
        outLabel.textContent = "Tile output:";
        outputRow.appendChild(outLabel);
        this.outputButtons_ = {};
        [
            [
                "code",
                "Code"
            ],
            [
                "wkt",
                "WKT"
            ]
        ].forEach(([value, text])=>{
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "caj-nav-btn draw-output-btn";
            btn.textContent = text;
            btn.title = value === "code" ? "Tile click writes the tile code" : "Tile click writes a WKT polygon";
            btn.setAttribute("aria-pressed", String(value === this.tileOutput_));
            btn.addEventListener("click", ()=>this.setTileOutput_(value));
            this.outputButtons_[value] = btn;
            outputRow.appendChild(btn);
        });
        root.appendChild(outputRow);
    }
    makeToolButton_(tool) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "caj-nav-btn draw-tool-btn";
        btn.title = tool.title;
        btn.setAttribute("aria-label", tool.title);
        btn.setAttribute("aria-pressed", "false");
        btn.innerHTML = (0, _drawIcons.DRAW_ICONS)[tool.icon];
        btn.addEventListener("click", ()=>this.selectTool_(tool.id));
        this.toolButtons_[tool.id] = btn;
        return btn;
    }
    actionButton_(icon, text, title, onClick) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "caj-nav-btn draw-action-btn";
        btn.title = title;
        btn.setAttribute("aria-label", title);
        btn.innerHTML = (0, _drawIcons.DRAW_ICONS)[icon] + `<span>${text}</span>`;
        btn.addEventListener("click", onClick);
        return btn;
    }
    setTileOutput_(value) {
        this.tileOutput_ = value;
        Object.keys(this.outputButtons_).forEach((key)=>{
            this.outputButtons_[key].setAttribute("aria-pressed", String(key === value));
        });
    }
    // Point the shared level input at the active tile tool's range/label, clamping
    // the current value into the new range (or resetting to the tool's default).
    configureLevelInput_(tool) {
        this.levelInput_.min = String(tool.levelMin);
        this.levelInput_.max = String(tool.levelMax);
        this.levelInput_.title = `${tool.levelLabel} (${tool.levelMin}\u{2013}${tool.levelMax})`;
        this.levelText_.textContent = tool.levelLabel;
        const cur = parseInt(this.levelInput_.value, 10);
        if (Number.isNaN(cur) || cur < tool.levelMin || cur > tool.levelMax) this.levelInput_.value = String(tool.levelDefault);
    }
    tileLevel_() {
        const tool = this.activeTool_;
        const min = tool ? tool.levelMin : 0;
        const max = tool ? tool.levelMax : DEFAULT_LEVEL_MAX;
        const def = tool ? tool.levelDefault : DEFAULT_LEVEL;
        const v = parseInt(this.levelInput_.value, 10);
        if (Number.isNaN(v)) return def;
        return Math.max(min, Math.min(max, v));
    }
    // OL Draw sketch styler. Splits the in-progress geometry into committed
    // (solid edges + light fill) and the moving segment to the cursor (dashed).
    makeSketchStyle_(tool) {
        if (tool.id === "polygon") return (feature)=>{
            const geom = feature.getGeometry();
            const t = geom.getType();
            if (t === "Polygon") return this.committedMovingStyles_(geom.getCoordinates()[0], true);
            if (t === "Point") return VERTEX_STYLE;
            return []; // skip the duplicate sketch-line; the Polygon branch covers it
        };
        if (tool.id === "line") return (feature)=>{
            const geom = feature.getGeometry();
            const t = geom.getType();
            if (t === "LineString") return this.committedMovingStyles_(geom.getCoordinates(), false);
            if (t === "Point") return VERTEX_STYLE;
            return [];
        };
        // point / tiles (Point) and rectangle (Polygon, click-drag)
        return (feature)=>{
            const t = feature.getGeometry().getType();
            if (t === "Polygon") return BOX_STYLE;
            if (t === "LineString") return DASHED_STYLE;
            return VERTEX_STYLE;
        };
    }
    committedMovingStyles_(coords, isRing) {
        let r = coords;
        // A polygon ring is closed (last === first) while drawing; drop the dup so
        // the real cursor vertex is the last element.
        if (isRing && r.length > 1) {
            const a = r[0];
            const b = r[r.length - 1];
            if (a[0] === b[0] && a[1] === b[1]) r = r.slice(0, -1);
        }
        const n = r.length;
        if (n === 0) return [];
        const cursor = r[n - 1];
        const committed = r.slice(0, n - 1);
        const styles = [];
        if (isRing && committed.length >= 3) styles.push(new (0, _style.Style)({
            geometry: new (0, _polygonDefault.default)([
                [
                    ...committed,
                    committed[0]
                ]
            ]),
            fill: COMMITTED_FILL
        }));
        if (committed.length >= 2) styles.push(new (0, _style.Style)({
            geometry: new (0, _lineStringDefault.default)(committed),
            stroke: SOLID_STROKE
        }));
        if (committed.length >= 1) {
            styles.push(new (0, _style.Style)({
                geometry: new (0, _lineStringDefault.default)([
                    committed[committed.length - 1],
                    cursor
                ]),
                stroke: DASHED_STROKE
            }));
            if (isRing && committed.length >= 2) styles.push(new (0, _style.Style)({
                geometry: new (0, _lineStringDefault.default)([
                    cursor,
                    committed[0]
                ]),
                stroke: DASHED_STROKE
            }));
            styles.push(new (0, _style.Style)({
                geometry: new (0, _multiPointDefault.default)(committed),
                image: VERTEX_IMAGE
            }));
        }
        return styles;
    }
    selectTool_(id) {
        // Clicking the active tool again toggles it off.
        if (this.activeTool_ && this.activeTool_.id === id) {
            this.deactivate_();
            return;
        }
        this.deactivate_();
        const tool = ALL_TOOLS.find((t)=>t.id === id);
        if (!tool) return;
        this.activeTool_ = tool;
        this.toolButtons_[id].setAttribute("aria-pressed", "true");
        if (tool.tile) this.configureLevelInput_(tool);
        this.draw_ = new (0, _drawDefault.default)({
            source: this.sketchSource_,
            type: tool.type,
            geometryFunction: tool.box ? (0, _draw.createBox)() : undefined,
            style: this.makeSketchStyle_(tool)
        });
        this.draw_.on("drawstart", ()=>{
            this.drawing_ = true;
            if (tool.multiVertex) {
                this.actionsRow_.hidden = false;
                this.setStatus_(CONTINUE_HINT[tool.id]);
            }
        });
        this.draw_.on("drawend", (e)=>this.handleDrawEnd_(e));
        this.draw_.on("drawabort", ()=>{
            this.drawing_ = false;
            this.actionsRow_.hidden = true;
            this.setStatus_(START_HINT[tool.id]);
        });
        this.olMap_.addInteraction(this.draw_);
        if (tool.tile) this.startTilePreview_();
        this.olMap_.getViewport().classList.add("draw-crosshair");
        document.addEventListener("keydown", this.onKeyDown_);
        this.setStatus_(START_HINT[tool.id]);
    }
    handleDrawEnd_(e) {
        const tool = this.activeTool_;
        const wantWkt = this.tileOutput_ === "wkt";
        let output;
        if (tool && tool.tile) {
            const [lon, lat] = (0, _proj.toLonLat)(e.feature.getGeometry().getCoordinates());
            const level = this.tileLevel_();
            const code = (0, _mortonTile.mortonCodeFromCoordinate)(lon, lat, level);
            output = wantWkt ? (0, _mortonTile.mortonWktFromCode)(code) : code;
        } else output = roundWkt(this.wktFormat_.writeGeometry(e.feature.getGeometry(), {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3857"
        }));
        // Overwrite the box without moving the view (the user clicked where they look).
        this.wktControl_.set("zoomToExtent", false);
        this.wktControl_.set("wkt", output);
        // Tear down after the interaction's own event dispatch settles.
        window.setTimeout(()=>this.deactivate_(), 0);
    }
    finish_() {
        if (this.draw_ && this.activeTool_ && this.activeTool_.multiVertex) this.draw_.finishDrawing();
    }
    undo_() {
        if (this.draw_) this.draw_.removeLastPoint();
    }
    cancel_() {
        if (this.draw_ && this.drawing_) this.draw_.abortDrawing();
        else this.deactivate_();
    }
    startTilePreview_() {
        if (this.tilePreviewActive_) return;
        this.tilePreviewActive_ = true;
        this.olMap_.addLayer(this.tilePreviewLayer_);
        this.olMap_.on("pointermove", this.onPointerMove_);
        this.olMap_.getViewport().addEventListener("pointerleave", this.onPointerLeave_);
    }
    stopTilePreview_() {
        if (this.tilePreviewActive_) {
            this.tilePreviewActive_ = false;
            this.olMap_.un("pointermove", this.onPointerMove_);
            this.olMap_.getViewport().removeEventListener("pointerleave", this.onPointerLeave_);
            this.olMap_.removeLayer(this.tilePreviewLayer_);
        }
        this.clearTilePreview_();
    }
    handlePointerMove_(e) {
        if (!this.activeTool_ || !this.activeTool_.tile || e.dragging) return;
        this.lastPreviewCoordinate_ = e.coordinate;
        this.scheduleTilePreview_(e.coordinate);
    }
    handlePointerLeave_() {
        this.lastPreviewCoordinate_ = null;
        this.clearTilePreview_();
    }
    refreshTilePreview_() {
        this.tilePreviewCode_ = null;
        if (this.tilePreviewActive_ && this.lastPreviewCoordinate_) this.scheduleTilePreview_(this.lastPreviewCoordinate_);
    }
    scheduleTilePreview_(coordinate) {
        this.pendingPreviewCoordinate_ = coordinate;
        if (this.tilePreviewFrame_ !== null) return;
        this.tilePreviewFrame_ = window.requestAnimationFrame(()=>{
            this.tilePreviewFrame_ = null;
            const pending = this.pendingPreviewCoordinate_;
            this.pendingPreviewCoordinate_ = null;
            this.renderTilePreview_(pending);
        });
    }
    renderTilePreview_(coordinate) {
        if (!coordinate || !this.activeTool_ || !this.activeTool_.tile) {
            this.clearTilePreview_();
            return;
        }
        const [lon, lat] = (0, _proj.toLonLat)(coordinate);
        const code = (0, _mortonTile.mortonCodeFromCoordinate)(lon, lat, this.tileLevel_());
        if (code === this.tilePreviewCode_ && this.tilePreviewFeature_) return;
        const ring = (0, _mortonTile.mortonRingFromCode)(code).map(([ringLon, ringLat])=>(0, _proj.fromLonLat)([
                ringLon,
                ringLat
            ]));
        const geometry = new (0, _polygonDefault.default)([
            ring
        ]);
        if (!this.tilePreviewFeature_) {
            this.tilePreviewFeature_ = new (0, _featureDefault.default)({
                geometry
            });
            this.tilePreviewSource_.addFeature(this.tilePreviewFeature_);
        } else this.tilePreviewFeature_.setGeometry(geometry);
        this.tilePreviewFeature_.set("mortonCode", code);
        this.tilePreviewCode_ = code;
    }
    clearTilePreview_() {
        if (this.tilePreviewFrame_ !== null) {
            window.cancelAnimationFrame(this.tilePreviewFrame_);
            this.tilePreviewFrame_ = null;
        }
        this.pendingPreviewCoordinate_ = null;
        this.tilePreviewCode_ = null;
        this.tilePreviewFeature_ = null;
        this.tilePreviewSource_.clear();
    }
    deactivate_() {
        this.stopTilePreview_();
        if (this.draw_) {
            if (this.drawing_) this.draw_.abortDrawing();
            this.olMap_.removeInteraction(this.draw_);
            this.draw_ = null;
        }
        this.sketchSource_.clear();
        this.drawing_ = false;
        if (this.activeTool_) {
            this.toolButtons_[this.activeTool_.id].setAttribute("aria-pressed", "false");
            this.activeTool_ = null;
        }
        this.actionsRow_.hidden = true;
        this.setStatus_(null);
        this.olMap_.getViewport().classList.remove("draw-crosshair");
        document.removeEventListener("keydown", this.onKeyDown_);
    }
    setStatus_(text) {
        if (!text) {
            this.statusEl_.hidden = true;
            this.statusEl_.textContent = "";
            return;
        }
        this.statusEl_.hidden = false;
        this.statusEl_.textContent = text;
    }
    handleKeyDown_(e) {
        // Don't hijack keys while the user is typing in a field (e.g. the WKT box).
        const tag = e.target && e.target.tagName || "";
        if (/^(input|textarea|select)$/i.test(tag) || e.target && e.target.isContentEditable) return;
        if (!this.draw_) return;
        if (e.key === "Enter") {
            this.finish_();
            e.preventDefault();
        } else if (e.key === "Backspace" || (e.ctrlKey || e.metaKey) && (e.key === "z" || e.key === "Z")) {
            this.undo_();
            e.preventDefault();
        } else if (e.key === "Escape") {
            this.cancel_();
            e.preventDefault();
        }
    }
}

},{"ol/control/Control":"8KSMn","ol/Feature":"iVSSP","ol/interaction/Draw":"hyiBx","ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","ol/format/WKT":"34shs","ol/geom/LineString":"223qD","ol/geom/Polygon":"3zws5","ol/geom/MultiPoint":"jiQtb","ol/proj":"gN0IK","ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"./drawIcons":"hAtHQ","../util/mortonTile":"2CSvZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hyiBx":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Draw
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Draw~Draw} instances are
 * instances of this type.
 */ parcelHelpers.export(exports, "DrawEvent", ()=>DrawEvent);
/**
 * Create a `geometryFunction` for `type: 'Circle'` that will create a regular
 * polygon with a user specified number of sides and start angle instead of a
 * {@link import("../geom/Circle.js").Circle} geometry.
 * @param {number} [sides] Number of sides of the regular polygon.
 *     Default is 32.
 * @param {number} [angle] Angle of the first point in counter-clockwise
 *     radians. 0 means East.
 *     Default is the angle defined by the heading from the center of the
 *     regular polygon to the current pointer position.
 * @return {GeometryFunction} Function that draws a polygon.
 * @api
 */ parcelHelpers.export(exports, "createRegularPolygon", ()=>createRegularPolygon);
/**
 * Create a `geometryFunction` that will create a box-shaped polygon (aligned
 * with the coordinate system axes).  Use this with the draw interaction and
 * `type: 'Circle'` to return a box instead of a circle geometry.
 * @return {GeometryFunction} Function that draws a box-shaped polygon.
 * @api
 */ parcelHelpers.export(exports, "createBox", ()=>createBox);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _mapBrowserEventJs = require("../MapBrowserEvent.js");
var _mapBrowserEventJsDefault = parcelHelpers.interopDefault(_mapBrowserEventJs);
var _mapBrowserEventTypeJs = require("../MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _coordinateJs = require("../coordinate.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _conditionJs = require("../events/condition.js");
var _extentJs = require("../extent.js");
var _functionsJs = require("../functions.js");
var _circleJs = require("../geom/Circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _lineStringJs = require("../geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("../geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("../geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("../geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("../geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _simpleGeometryJs = require("../geom/SimpleGeometry.js");
var _vectorJs = require("../layer/Vector.js");
var _vectorJsDefault = parcelHelpers.interopDefault(_vectorJs);
var _projJs = require("../proj.js");
var _vectorJs1 = require("../source/Vector.js");
var _vectorJsDefault1 = parcelHelpers.interopDefault(_vectorJs1);
var _styleJs = require("../style/Style.js");
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _propertyJs = require("./Property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _tracingJs = require("./tracing.js");
/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * @typedef {import('./tracing.js').LineCoordType} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /** @typedef {import('./tracing.js').TraceState} TraceState */ /** @typedef {import('./tracing.js').TraceTarget} TraceTarget */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: 'drawstart',
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: 'drawend',
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: 'drawabort'
};
class DrawEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class Draw extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, _functionsJs.FALSE);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {Options}
     * @private
     */ this.options_ = options;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * Ignore the next up event. This is set to `true` when a drag event is encountered,
     * e.g. when the user pans the map while drawing. In this case, we do not want to bail
     * out of tracing.
     * @type {boolean}
     * @private
     */ this.ignoreNextUpEvent_ = false;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === 'Polygon' ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === 'Circle' ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, _functionsJs.TRUE);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : 'XY';
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === 'Circle') /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, _circleJsDefault.default)([
                    NaN,
                    NaN
                ]);
                const center = (0, _projJs.fromUserCoordinate)(coordinates[0], projection);
                const squaredLength = (0, _coordinateJs.squaredDistance)(center, (0, _projJs.fromUserCoordinate)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, _projJs.getUserProjection)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === 'Point') Constructor = (0, _pointJsDefault.default);
                else if (mode === 'LineString') Constructor = (0, _lineStringJsDefault.default);
                else if (mode === 'Polygon') Constructor = (0, _polygonJsDefault.default);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === 'Polygon') {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, _vectorJsDefault.default)({
            source: new (0, _vectorJsDefault1.default)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, _conditionJs.noModifierKeys);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, _conditionJs.always);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, _conditionJs.shiftKeyOnly);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, _propertyJsDefault.default).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, _conditionJs.never);
        else if (trace === true) condition = (0, _conditionJs.always);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Set whether the drawing is done in freehand mode.
   *
   * @param {boolean} freehand Freehand drawing.
   * @api
   */ setFreehand(freehand) {
        this.freehand_ = freehand;
        if (this.freehand_) this.freehandCondition_ = (0, _conditionJs.always);
        else this.freehandCondition_ = this.options_ && this.options_.freehandCondition ? this.options_.freehandCondition : (0, _conditionJs.shiftKeyOnly);
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Get if this interaction is in freehand mode.
   * @return {boolean} Freehand drawing.
   * @api
   */ getFreehand() {
        return this.freehand_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, _eventTypeJsDefault.default).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === 'mouse' || event.type === (0, _mapBrowserEventTypeJsDefault.default).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, _mapBrowserEventTypeJsDefault.default).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, _extentJs.boundingExtent)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = (0, _tracingJs.getTraceTargets)(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startCoord: event.coordinate.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push((0, _tracingJs.getCoordinate)(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push((0, _tracingJs.getCoordinate)(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            const startPx = event.map.getPixelFromCoordinate(traceState.startCoord);
            if ((0, _coordinateJs.distance)(startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = (0, _tracingJs.getTraceTargetUpdate)(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = (0, _tracingJs.interpolateCoordinate)(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle drag events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @override
   */ handleDragEvent(event) {
        this.ignoreNextUpEvent_ = true;
        super.handleDragEvent(event);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            if (!this.ignoreNextUpEvent_) this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === 'Point')) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        this.ignoreNextUpEvent_ = false;
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === 'Point') at = true;
            else if (mode === 'Circle') at = this.sketchCoords_.length === 2;
            else if (mode === 'LineString') potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === 'Polygon') {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, _featureJsDefault.default)(new (0, _pointJsDefault.default)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, _featureJsDefault.default)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, _lineStringJsDefault.default)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, _simpleGeometryJs.getStrideForLayout)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === 'Point') this.sketchCoords_ = start.slice();
        else if (this.mode_ === 'Polygon') {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, _featureJsDefault.default)(new (0, _lineStringJsDefault.default)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, _featureJsDefault.default)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, _simpleGeometryJs.getStrideForLayout)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === 'Point') last = this.sketchCoords_;
        else if (this.mode_ === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === 'Polygon' && this.mode_ !== 'Polygon') this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === 'LineString' || mode === 'Circle') {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === 'LineString' || mode === 'Circle') {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === 'Polygon' && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === 'Polygon') {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === 'LineString') {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === 'Polygon') {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === 'MultiPoint') sketchFeature.setGeometry(new (0, _multiPointJsDefault.default)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiLineString') sketchFeature.setGeometry(new (0, _multiLineStringJsDefault.default)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiPolygon') sketchFeature.setGeometry(new (0, _multiPolygonJsDefault.default)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new DrawEvent(DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === 'LineString' || mode === 'Circle') sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === 'Polygon') sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, _featureJsDefault.default)(new (0, _pointJsDefault.default)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function getDefaultStyleFunction() {
    const styles = (0, _styleJs.createEditingStyle)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function createRegularPolygon(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, _projJs.fromUserCoordinate)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, _projJs.fromUserCoordinate)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, _coordinateJs.squaredDistance)(center, end));
        geometry = geometry || (0, _polygonJs.fromCircle)(new (0, _circleJsDefault.default)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, _polygonJs.makeRegular)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, _projJs.getUserProjection)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function createBox() {
    return function(coordinates, geometry, projection) {
        const extent = (0, _extentJs.boundingExtent)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, _projJs.fromUserCoordinate)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, _extentJs.getBottomLeft)(extent),
                (0, _extentJs.getBottomRight)(extent),
                (0, _extentJs.getTopRight)(extent),
                (0, _extentJs.getTopLeft)(extent),
                (0, _extentJs.getBottomLeft)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, _polygonJsDefault.default)(boxCoordinates);
        const userProjection = (0, _projJs.getUserProjection)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function getMode(type) {
    switch(type){
        case 'Point':
        case 'MultiPoint':
            return 'Point';
        case 'LineString':
        case 'MultiLineString':
            return 'LineString';
        case 'Polygon':
        case 'MultiPolygon':
            return 'Polygon';
        case 'Circle':
            return 'Circle';
        default:
            throw new Error('Invalid type: ' + type);
    }
}
exports.default = Draw;

},{"../Feature.js":"iVSSP","../MapBrowserEvent.js":"1ZNR4","../MapBrowserEventType.js":"dp3yB","../coordinate.js":"9bcSP","../events/Event.js":"5kI1G","../events/EventType.js":"79Bvl","../events/condition.js":"2tMOf","../extent.js":"MPjK5","../functions.js":"5nAKV","../geom/Circle.js":"13EZt","../geom/LineString.js":"223qD","../geom/MultiLineString.js":"5Cre5","../geom/MultiPoint.js":"jiQtb","../geom/MultiPolygon.js":"6i4VN","../geom/Point.js":"95T6m","../geom/Polygon.js":"3zws5","../geom/SimpleGeometry.js":"5Lm1Z","../layer/Vector.js":"7ga2c","../proj.js":"gN0IK","../source/Vector.js":"7zHxp","../style/Style.js":"gqpPW","./Pointer.js":"hxa0H","./Property.js":"4UwNl","./tracing.js":"7RBun","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7RBun":[function(require,module,exports,__globalThis) {
/**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {LineCoordType} coordinates The ring coordinates.
 * @param {number} index The index.  May be wrapped.
 * @return {import("../coordinate.js").Coordinate} The coordinate.
 */ parcelHelpers.export(exports, "getCoordinate", ()=>getCoordinate);
/**
 * @param {LineCoordType} coordinates The coordinates.
 * @param {number} index The index.  May be fractional and may wrap.
 * @return {import("../coordinate.js").Coordinate} The interpolated coordinate.
 */ parcelHelpers.export(exports, "interpolateCoordinate", ()=>interpolateCoordinate);
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {TraceState} traceState The trace state.
 * @param {import("../Map.js").default} map The map.
 * @param {number} snapTolerance The snap tolerance.
 * @return {TraceTargetUpdateInfo} Information about the new trace target.  The returned
 * object is reused between calls and must not be modified by the caller.
 */ parcelHelpers.export(exports, "getTraceTargetUpdate", ()=>getTraceTargetUpdate);
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {Array<import("../Feature.js").default>} features The candidate features.
 * @return {Array<TraceTarget>} The trace targets.
 */ parcelHelpers.export(exports, "getTraceTargets", ()=>getTraceTargets);
/**
 * @param {number} x The point x.
 * @param {number} y The point y.
 * @param {import("../coordinate.js").Coordinate} start The segment start.
 * @param {import("../coordinate.js").Coordinate} end The segment end.
 * @return {PointSegmentRelationship} The point segment relationship.  The returned object is
 * shared between calls and must not be modified by the caller.
 */ parcelHelpers.export(exports, "getPointSegmentRelationship", ()=>getPointSegmentRelationship);
var _coordinateJs = require("../coordinate.js");
var _geometryCollectionJs = require("../geom/GeometryCollection.js");
var _geometryCollectionJsDefault = parcelHelpers.interopDefault(_geometryCollectionJs);
var _lineStringJs = require("../geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("../geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPolygonJs = require("../geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _mathJs = require("../math.js");
function getCoordinate(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
function interpolateCoordinate(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../coordinate.js").Coordinate} [startCoord] The initially clicked coordinate.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 * @property {number} closestTargetDistance The squared distance to the closest target.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const sharedUpdateInfo = {
    index: -1,
    endIndex: NaN,
    closestTargetDistance: Infinity
};
function getTraceTargetUpdate(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = getPointSegmentRelationship(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = interpolateCoordinate(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        const startPx = map.getPixelFromCoordinate(traceState.startCoord);
        if ((0, _coordinateJs.distance)(pixel, startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    sharedUpdateInfo.index = newTargetIndex;
    sharedUpdateInfo.endIndex = newEndIndex;
    sharedUpdateInfo.closestTargetDistance = closestTargetDistance;
    return sharedUpdateInfo;
}
function getTraceTargets(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, _lineStringJsDefault.default)) {
        appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, _multiLineStringJsDefault.default)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, _polygonJsDefault.default)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, _multiPolygonJsDefault.default)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, _geometryCollectionJsDefault.default)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = getPointSegmentRelationship(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function getSquaredDistance(a, b) {
    return (0, _mathJs.squaredDistance)(a[0], a[1], b[0], b[1]);
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = interpolateCoordinate(coordinates, lowIndex);
        const end = interpolateCoordinate(coordinates, highIndex);
        return getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = interpolateCoordinate(coordinates, lowIndex);
        const end = getCoordinate(coordinates, lowWholeIndex);
        sd += getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = getCoordinate(coordinates, highWholeIndex);
        const end = interpolateCoordinate(coordinates, highIndex);
        sd += getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = getCoordinate(coordinates, i);
        const end = getCoordinate(coordinates, i + 1);
        sd += getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const sharedRel = {
    along: 0,
    squaredDistance: 0
};
function getPointSegmentRelationship(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, _mathJs.clamp)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    sharedRel.along = along;
    sharedRel.squaredDistance = (0, _mathJs.toFixed)((0, _mathJs.squaredDistance)(x, y, px, py), 10);
    return sharedRel;
}

},{"../coordinate.js":"9bcSP","../geom/GeometryCollection.js":"aO2BB","../geom/LineString.js":"223qD","../geom/MultiLineString.js":"5Cre5","../geom/MultiPolygon.js":"6i4VN","../geom/Polygon.js":"3zws5","../math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hAtHQ":[function(require,module,exports,__globalThis) {
/**
 * Inline SVG icons for the drawing toolbar.
 *
 * Authored in-house (no external icon dependency). `stroke`/`fill` use
 * `currentColor` so buttons theme the glyphs via CSS (hover / active states).
 * All glyphs share a 0 0 20 20 viewBox and round line joins.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DRAW_ICONS", ()=>DRAW_ICONS);
const svg = (inner)=>`<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${inner}</svg>`;
const DRAW_ICONS = {
    point: svg('<circle cx="10" cy="10" r="3.2" fill="currentColor" stroke="none"/><circle cx="10" cy="10" r="6"/>'),
    line: svg('<polyline points="3.5,15 8.5,7 12,12 16.5,5"/><circle cx="3.5" cy="15" r="1.7" fill="currentColor" stroke="none"/><circle cx="16.5" cy="5" r="1.7" fill="currentColor" stroke="none"/>'),
    polygon: svg('<polygon points="10,3.5 16.5,8 14,16.5 6,16.5 3.5,8"/>'),
    rectangle: svg('<rect x="3.5" y="5.5" width="13" height="9" rx="0.5"/>'),
    morton: svg('<rect x="3.5" y="3.5" width="5.5" height="5.5"/><rect x="11" y="3.5" width="5.5" height="5.5"/><rect x="3.5" y="11" width="5.5" height="5.5"/><rect x="11" y="11" width="5.5" height="5.5"/>'),
    finish: svg('<polyline points="4,10.5 8.5,15 16,5"/>'),
    undo: svg('<polyline points="8,6 4,10 8,14"/><path d="M4 10 h8 a4 4 0 0 1 0 8 h-1.5"/>'),
    cancel: svg('<line x1="5.5" y1="5.5" x2="14.5" y2="14.5"/><line x1="14.5" y1="5.5" x2="5.5" y2="14.5"/>')
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jJjT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLayersAndControls", ()=>addLayersAndControls);
var _navigability = require("../layers/interactions/navigability");
var _gradient = require("../layers/interactions/gradient");
var _dualCarriageway = require("../layers/interactions/dualCarriageway");
var _oneway = require("../layers/interactions/oneway");
var _dualCarriageway1 = require("../layers/style/dualCarriageway");
var _oneway1 = require("../layers/style/oneway");
var _osmOneway = require("../layers/style/osmOneway");
var _gradient1 = require("../layers/style/gradient");
var _navigability1 = require("../layers/style/navigability");
var _lez = require("../layers/style/lez");
var _lez1 = require("../layers/interactions/lez");
var _ramp = require("../layers/style/ramp");
var _lrtc = require("../layers/style/lrtc");
var _ramp1 = require("../layers/interactions/ramp");
var _lrtc1 = require("../layers/interactions/lrtc");
var _curvature = require("../layers/style/curvature");
var _crosslink = require("../layers/style/crosslink");
var _crosslink1 = require("../layers/interactions/crosslink");
var _hdmap = require("../layers/style/hdmap");
var _hdmap1 = require("../layers/interactions/hdmap");
var _hdlaneborder = require("../layers/style/hdlaneborder");
var _genericInternal = require("../layers/interactions/genericInternal");
var _genericInternal1 = require("../layers/style/genericInternal");
var _ttnavInternal = require("../layers/interactions/ttnavInternal");
var _ttnavInternal1 = require("../layers/style/ttnavInternal");
var _moderation = require("../layers/interactions/moderation");
var _moderation1 = require("../layers/style/moderation");
var _wfslayersAndControls = require("./WFSLayersAndControls");
var _fgblayersAndControls = require("./FGBLayersAndControls");
var _parameters = require("../parameters/parameters");
var _crosslinkHoverLayer = require("../layers/CrosslinkHoverLayer");
var _crosslinkLayerHandler = require("../layers/featureinfohandlers/CrosslinkLayerHandler");
var _defaultHoverStyle = require("../layers/style/hover/defaultHoverStyle");
var _drivingDirectionHoverStyle = require("../layers/style/hover/drivingDirectionHoverStyle");
var _curvatureHoverStyle = require("../layers/style/hover/curvatureHoverStyle");
var _hdlaneborder1 = require("../layers/interactions/hdlaneborder");
var _hdlanefunction = require("../layers/style/hdlanefunction");
var _hdlanefunction1 = require("../layers/interactions/hdlanefunction");
var _hdLaneRestriction = require("../layers/style/hdLaneRestriction");
var _hdLaneRestriction1 = require("../layers/interactions/hdLaneRestriction");
var _curvature1 = require("../layers/interactions/curvature");
var _hdLaneWidth = require("../layers/style/hdLaneWidth");
var _hdLaneWidth1 = require("../layers/interactions/hdLaneWidth");
var _osmLanesNorm = require("../layers/style/osmLanesNorm");
var _osmLanesNorm1 = require("../layers/interactions/osmLanesNorm");
var _controlledAccess = require("../layers/style/controlledAccess");
var _controlledAccess1 = require("../layers/interactions/controlledAccess");
var _curvatureAtJunctionArcHandler = require("../layers/addfeaturehandlers/CurvatureAtJunctionArcHandler");
var _curvatureLinearHandler = require("../layers/addfeaturehandlers/CurvatureLinearHandler");
var _crosslinkCoverageHandler = require("../layers/addfeaturehandlers/CrosslinkCoverageHandler");
var _curvatureAtJunction = require("../layers/style/curvatureAtJunction");
var _curvatureAtJunction1 = require("../layers/interactions/curvatureAtJunction");
var _sdLaneRestriction = require("../layers/style/sdLaneRestriction");
var _sdLaneRestriction1 = require("../layers/interactions/sdLaneRestriction");
function addLayersAndControls(map, azureLoginControl, featureInfoControl, target) {
    // one way
    //curvature
    const curvatureCollapse = getCollapsible("Curvature");
    const onewayCollapse = getCollapsible("Oneway");
    const dcwCollapse = getCollapsible("Dualcarriageway");
    const navCollapse = getCollapsible("Navigability");
    const gradientCollapse = getCollapsible("Gradient");
    const hdCollapse = getCollapsible("HD");
    const lezCollapse = getCollapsible("LEZ");
    const lanerestriction = getCollapsible("Lane Restrictions");
    const rampCollapse = getCollapsible("Ramp");
    target.appendChild(onewayCollapse);
    target.appendChild(navCollapse);
    target.appendChild(dcwCollapse);
    target.appendChild(lezCollapse);
    target.appendChild(rampCollapse);
    target.appendChild(gradientCollapse);
    target.appendChild(curvatureCollapse);
    target.appendChild(hdCollapse);
    target.appendChild(lanerestriction);
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "One way dev 28798",
        url: "/orbis-wfs-oneway-dev-28798",
        role: "orbis-wfs-oneway-dev-28798",
        style: (0, _oneway1.getOnewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: onewayCollapse,
        map: map,
        getInteractions: (0, _oneway.getOnewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "One way prod 21591",
        url: "/orbis-wfs-oneway-prod-21591",
        role: "orbis-wfs-oneway-prod-21591",
        style: (0, _oneway1.getOnewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: onewayCollapse,
        map: map,
        getInteractions: (0, _oneway.getOnewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // osm one way
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "OSM one way dev 17772",
        url: "/orbis-wfs-osm-oneway-dev-17772",
        role: "orbis-wfs-osm-oneway-dev-17772",
        style: (0, _osmOneway.getOsmOnewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: onewayCollapse,
        map: map,
        getInteractions: (0, _oneway.getOnewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "OSM one way prod 26874",
        url: "/orbis-wfs-osm-oneway-prod-26874",
        role: "orbis-wfs-osm-oneway-prod-26874",
        style: (0, _osmOneway.getOsmOnewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: onewayCollapse,
        map: map,
        getInteractions: (0, _oneway.getOnewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // dual carriageway
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Dual carriageway dev 22398",
        url: "/orbis-wfs-dcw-dev-22398",
        role: "orbis-wfs-dcw-dev-22398",
        style: (0, _dualCarriageway1.getDualCarriagewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: dcwCollapse,
        map: map,
        getInteractions: (0, _dualCarriageway.getDualCarriagewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Dual carriageway prod 28200",
        url: "/orbis-wfs-dcw-prod-28200",
        role: "orbis-wfs-dcw-prod-28200",
        style: (0, _dualCarriageway1.getDualCarriagewayStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: dcwCollapse,
        map: map,
        getInteractions: (0, _dualCarriageway.getDualCarriagewayInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // tt-navigabilility
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "TT-Navigability dev 19150",
        url: "/orbis-wfs-ttnav-dev-19150",
        role: "orbis-wfs-ttnav-dev-19150",
        style: (0, _navigability1.getNavigabilityStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: navCollapse,
        map: map,
        getInteractions: (0, _navigability.getNavigabilityInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "TT-Navigability prod 20063",
        url: "/orbis-wfs-ttnav-prod-20063",
        role: "orbis-wfs-ttnav-prod-20063",
        style: (0, _navigability1.getNavigabilityStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: navCollapse,
        map: map,
        getInteractions: (0, _navigability.getNavigabilityInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // osm-navigability
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "OSM-Navigability dev 27657",
        url: "/orbis-wfs-osmnav-dev-27657",
        role: "orbis-wfs-ttnav-dev-19150",
        style: (0, _navigability1.getNavigabilityStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: navCollapse,
        map: map,
        getInteractions: (0, _navigability.getNavigabilityInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "OSM-Navigability prod 11442",
        url: "/orbis-wfs-osmnav-prod-11442",
        role: "orbis-wfs-ttnav-prod-20063",
        style: (0, _navigability1.getNavigabilityStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: navCollapse,
        map: map,
        getInteractions: (0, _navigability.getNavigabilityInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // gradient
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Gradient hd dev 30426 [disabled]",
        url: "/orbis-wfs-gradient-dev-30426",
        role: "orbis-wfs-gradient-dev-30426",
        style: (0, _gradient1.getGradientStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: gradientCollapse,
        map: map,
        getInteractions: (0, _gradient.getGradientInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Gradient dev 13999",
        url: "/orbis-wfs-gradient-dev-13999",
        role: "orbis-wfs-gradient-dev-13999",
        style: (0, _gradient1.getGradientStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: gradientCollapse,
        map: map,
        getInteractions: (0, _gradient.getGradientInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Gradient prod 11880",
        url: "/orbis-wfs-gradient-prod-11880",
        role: "orbis-wfs-gradient-prod-11880",
        style: (0, _gradient1.getGradientStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: gradientCollapse,
        map: map,
        getInteractions: (0, _gradient.getGradientInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Genesis SD gradient",
        target: gradientCollapse,
        map: map,
        getInteractions: (0, _gradient.getGradientInteractions),
        sortField: "inserted_at",
        urls: [
            "/genesis-gradient/genesis-gradient-from-csv.fgb"
        ],
        style: (0, _gradient1.getGradientStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Gradient DEM prod 18758",
        url: "/orbis-wfs-gradient-prod-18758",
        role: "orbis-wfs-gradient-prod-18758",
        style: (0, _gradient1.getGradientStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: gradientCollapse,
        map: map,
        getInteractions: (0, _gradient.getGradientInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    //curvature
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM Curvature prod 20906",
        url: "/orbis-wfs-curvature-prod-20906",
        role: "orbis-wfs-curvature-prod-20906",
        style: (0, _curvature.getCurvatureStyleNormalOrbisHD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisHD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisHD)(),
            (0, _drivingDirectionHoverStyle.drivingDirectionHoverStyles)
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM Curvature dev 50761",
        url: "/orbis-wfs-curvature-dev-50761",
        role: "orbis-wfs-curvature-dev-50761",
        style: (0, _curvature.getCurvatureStyleNormalOrbisHD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisHD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisHD)(),
            (0, _drivingDirectionHoverStyle.drivingDirectionHoverStyles)
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM2RM Curvature prod 15751",
        url: "/orbis-wfs-curvature-prod-15751",
        role: "orbis-wfs-curvature-prod-15751",
        style: (0, _curvature.getCurvatureStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM2RM Curvature dev 15916",
        url: "/orbis-wfs-curvature-dev-15916",
        role: "orbis-wfs-curvature-dev-15916",
        style: (0, _curvature.getCurvatureStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Curvature prod 23405",
        url: "/orbis-wfs-osmcurvature-prod-23405",
        role: "orbis-wfs-osmcurvature-prod-23405",
        style: (0, _curvature.getCurvatureStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Curvature dev 15702",
        url: "/orbis-wfs-osmcurvature-dev-15702",
        role: "orbis-wfs-osmcurvature-dev-15702",
        style: (0, _curvature.getCurvatureStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStyles)("#695f01")
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Curvature Cariad prod 97905",
        url: "/orbis-wfs-osmcurvature-prod-97905",
        role: "orbis-wfs-osmcurvature-prod-97905",
        style: (0, _curvature.getCurvatureStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "CaJ RM prod 64504",
        url: "/orbis-wfs-osmcaj-prod-64504",
        role: "orbis-wfs-osmcaj-prod-64504",
        style: (0, _curvatureAtJunction.getCaJStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvatureAtJunction1.getCaJInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        // CaJ draws its own travel-direction arrows on the offset line, so the generic
        // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
        // and visibly off the displayed line — leave it out, keep only the curvature circle.
        hoverStyleFunctions: [
            (0, _curvatureHoverStyle.curvatureAtJunctionHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureAtJunctionArcHandler.curvatureAtJunctionArcHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "CaJ RM dev 66578",
        url: "/orbis-wfs-osmcaj-dev-66578",
        role: "orbis-wfs-osmcaj-dev-66578",
        style: (0, _curvatureAtJunction.getCaJStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvatureAtJunction1.getCaJInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        // CaJ draws its own travel-direction arrows on the offset line, so the generic
        // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
        // and visibly off the displayed line — leave it out, keep only the curvature circle.
        hoverStyleFunctions: [
            (0, _curvatureHoverStyle.curvatureAtJunctionHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureAtJunctionArcHandler.curvatureAtJunctionArcHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM-derived CaJ dev 32286",
        url: "/orbis-wfs-lm2rmcaj-dev-32286",
        role: "orbis-wfs-lm2rmcaj-dev-32286",
        style: (0, _curvatureAtJunction.getCaJStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvatureAtJunction1.getCaJInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        // CaJ draws its own travel-direction arrows on the offset line, so the generic
        // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
        // and visibly off the displayed line — leave it out, keep only the curvature circle.
        hoverStyleFunctions: [
            (0, _curvatureHoverStyle.curvatureAtJunctionHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureAtJunctionArcHandler.curvatureAtJunctionArcHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM-derived CaJ prod 62511",
        url: "/orbis-wfs-lm2rmcaj-prod-62511",
        role: "orbis-wfs-lm2rmcaj-prod-62511",
        style: (0, _curvatureAtJunction.getCaJStyleNormalOrbisSD),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvatureAtJunction1.getCaJInteractionsOrbisSD)(),
        featureInfoHandlers: [],
        // CaJ draws its own travel-direction arrows on the offset line, so the generic
        // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
        // and visibly off the displayed line — leave it out, keep only the curvature circle.
        hoverStyleFunctions: [
            (0, _curvatureHoverStyle.curvatureAtJunctionHoverStylesOrbisSD)()
        ],
        addFeatureHandlers: [
            (0, _curvatureAtJunctionArcHandler.curvatureAtJunctionArcHandler)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Genesis RM Curvature",
        target: curvatureCollapse,
        map: map,
        getInteractions: (0, _curvature1.getCurvatureInteractionsGenesis)(),
        sortField: "inserted_at",
        urls: [
            "/genesis-curvatures/genesis-curvatures-from-csv.fgb"
        ],
        style: (0, _curvature.getCurvatureStyleNormalGenesis),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStylesGenesis)()
        ],
        addFeatureHandlers: [
            (0, _curvatureLinearHandler.curvatureLinearHandler)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Crosslink prod 32804 (incl. HAPT)",
        url: "/orbis-wfs-crosslink-32804",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _crosslink.getCrosslinkStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _crosslink1.getCrosslinkInteractions),
        featureInfoHandlers: [
            (0, _crosslinkLayerHandler.getCrosslinkLayerHander)((0, _crosslinkHoverLayer.addCrosslinkHoverLayer)(map).getSource())
        ],
        addFeatureHandlers: [
            (0, _crosslinkCoverageHandler.crosslinkCoverageHandler)
        ],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Crosslink staging 20986 (HDBM 29351)",
        url: "/orbis-wfs-crosslink-20986-29351",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _crosslink.getCrosslinkStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _crosslink1.getCrosslinkInteractions),
        featureInfoHandlers: [
            (0, _crosslinkLayerHandler.getCrosslinkLayerHander)((0, _crosslinkHoverLayer.addCrosslinkHoverLayer)(map).getSource())
        ],
        addFeatureHandlers: [
            (0, _crosslinkCoverageHandler.crosslinkCoverageHandler)
        ],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Crosslink staging 20986 (HDBM 27593)",
        url: "/orbis-wfs-crosslink-20986-27593",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _crosslink.getCrosslinkStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _crosslink1.getCrosslinkInteractions),
        featureInfoHandlers: [
            (0, _crosslinkLayerHandler.getCrosslinkLayerHander)((0, _crosslinkHoverLayer.addCrosslinkHoverLayer)(map).getSource())
        ],
        addFeatureHandlers: [
            (0, _crosslinkCoverageHandler.crosslinkCoverageHandler)
        ],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM Lane Restrictions prod 88259",
        url: "/orbis-wfs-hdlanerestriction-prod-88259",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _hdLaneRestriction.getHDLaneRestrictionStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _hdLaneRestriction1.getHDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM Lane Restrictions dev 91567",
        url: "/orbis-wfs-hdlanerestriction-dev-91567",
        role: "orbis-wfs-hdlanerestriction-dev-91567",
        style: (0, _hdLaneRestriction.getHDLaneRestrictionStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _hdLaneRestriction1.getHDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Lane Restrictions dev 26744 - HOV",
        url: "/orbis-wfs-sdlanerestriction-dev-26744",
        role: "orbis-wfs-sdlanerestriction-dev-26744",
        style: (0, _sdLaneRestriction.getSDLaneRestrictionHovStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _sdLaneRestriction1.getSDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Lane Restrictions dev 26744 - Vehicle Access",
        url: "/orbis-wfs-sdlanerestriction-dev-26744",
        role: "orbis-wfs-sdlanerestriction-dev-26744",
        style: (0, _sdLaneRestriction.getSDLaneRestrictionStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _sdLaneRestriction1.getSDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Lane Restrictions prod 21620 - HOV",
        url: "/orbis-wfs-sdlanerestriction-prod-21620",
        role: "orbis-wfs-sdlanerestriction-prod-21620",
        style: (0, _sdLaneRestriction.getSDLaneRestrictionHovStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _sdLaneRestriction1.getSDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "RM Lane Restrictions prod 21620 - Vehicle Access",
        url: "/orbis-wfs-sdlanerestriction-prod-21620",
        role: "orbis-wfs-sdlanerestriction-prod-21620",
        style: (0, _sdLaneRestriction.getSDLaneRestrictionStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _sdLaneRestriction1.getSDLaneRestrictionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "RM Lane Restrictions prod 21620 - internals",
        target: lanerestriction,
        map: map,
        getInteractions: (0, _genericInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/sdlaneres-internals/sdlaneres-statements-from-csv-", (0, _parameters.getSDLanerestrictionInternalMonths)()),
        style: (0, _genericInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "RM Lane Restrictions prod 21620 - moderations",
        target: lanerestriction,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "last_moderated_at",
        urls: [
            "/sdlaneres-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "last_moderated_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "LM Lane Restrictions internals prod",
        target: lanerestriction,
        map: map,
        getInteractions: (0, _genericInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/laneres-internals/hdlaneres-statements-from-csv-", (0, _parameters.getHDLanerestrictionInternalMonths)()),
        style: (0, _genericInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "LM Lane Restrictions moderations",
        target: lanerestriction,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "last_moderated_at",
        urls: [
            "/laneres-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "last_moderated_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LM Lane Function 38434",
        url: "/orbis-wfs-hdlanefunction-dev-38434",
        role: "orbis-wfs-hdlanerestriction-dev-91567",
        style: (0, _hdlanefunction.getHDLaneFunctionStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _hdlanefunction1.getHDLaneFunctionInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // addWFSLayerAndControl({
    //   layerName: "HD lane function 38434 (restriction view)",
    //   url: process.env.ORBIS_WFS_HDLANEFUNCTION_38434_URL,
    //   role: process.env.ORBIS_WFS_HDLANERESTRICTION_DEV_ROLE,
    //   style: getHDLaneRestrictionStyleNormal,
    //   azureLoginControl: azureLoginControl,
    //   featureInfoControl: featureInfoControl,
    //   div: hdlanerestriction,
    //   map: map,
    //   getInteractions: getHDLaneRestrictionInteractions,
    //   featureInfoHandlers: [],
    //   hoverStyleFunctions: [defaultHoverStyles],
    // });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "HD Basemap 29351 (incl HAPT)",
        url: "/orbis-wfs-hdlanefunction-dev-38434",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _hdmap.getHDMapStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _hdmap1.getHDMapInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _drivingDirectionHoverStyle.drivingDirectionHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "HD Lane borders 29351 (incl HAPT)",
        url: "/orbis-wfs-hdlanefunction-dev-38434",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _hdlaneborder.getHDLaneBorderStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _hdlaneborder1.getHDLaneBorderInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // lane width
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "HD Lane width dev 16712",
        url: "/orbis-wfs-lanewidth-dev-16712",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _hdLaneWidth.getHDLaneWidthStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _hdLaneWidth1.getHDLaneWidthInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "HD Lane width prod 49829",
        url: "/orbis-wfs-lanewidth-prod-49829",
        role: "orbis-wfs-hdlanerestriction-prod-88259",
        style: (0, _hdLaneWidth.getHDLaneWidthStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _hdLaneWidth1.getHDLaneWidthInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LRTC HD dev 74020",
        url: "/orbis-wfs-lrtc-dev-74020",
        role: "orbis-wfs-lrtc-dev-74020",
        style: (0, _lrtc.getLrtcStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _lrtc1.getLrtcInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStyles)("#5880b7")
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LRTC HD prod 93924",
        url: "/orbis-wfs-lrtc-prod-93924",
        role: "orbis-wfs-lrtc-prod-93924",
        style: (0, _lrtc.getLrtcStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: hdCollapse,
        map: map,
        getInteractions: (0, _lrtc1.getLrtcInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles),
            (0, _curvatureHoverStyle.curvatureHoverStyles)("#5880b7")
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Osm Lanes Norm prod 11361",
        url: "/orbis-wfs-osmlanesnorm-prod-11361",
        role: "orbis-wfs-osmlanesnorm-prod-11361",
        style: (0, _osmLanesNorm.getOsmLanesNormStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lanerestriction,
        map: map,
        getInteractions: (0, _osmLanesNorm1.getOsmLanesNormInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // lez
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LEZ dev 21372",
        url: "/orbis-wfs-lez-dev-21372",
        role: "orbis-wfs-lez-dev-21372",
        style: (0, _lez.getEmissionRegulationStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lezCollapse,
        map: map,
        getInteractions: (0, _lez1.getEmissionRegulationInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "LEZ prod 22666",
        url: "/orbis-wfs-lez-prod-22666",
        role: "orbis-wfs-lez-prod-22666",
        style: (0, _lez.getEmissionRegulationStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: lezCollapse,
        map: map,
        getInteractions: (0, _lez1.getEmissionRegulationInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    // ramp
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Controlled Access prod 16158",
        url: "/orbis-wfs-ramp-dev-90537",
        role: "orbis-wfs-ramp-dev-90537",
        style: (0, _controlledAccess.getControlledAccessStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: rampCollapse,
        map: map,
        getInteractions: (0, _controlledAccess1.getControlledAccessInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Ramp dev 90537",
        url: "/orbis-wfs-ramp-dev-90537",
        role: "orbis-wfs-ramp-dev-90537",
        style: (0, _ramp.getRampStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: rampCollapse,
        map: map,
        getInteractions: (0, _ramp1.getRampInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _wfslayersAndControls.addWFSLayerAndControl)({
        layerName: "Ramp prod 54757",
        url: "/orbis-wfs-ramp-prod-54757",
        role: "orbis-wfs-ramp-prod-54757",
        style: (0, _ramp.getRampStyleNormal),
        azureLoginControl: azureLoginControl,
        featureInfoControl: featureInfoControl,
        div: rampCollapse,
        map: map,
        getInteractions: (0, _ramp1.getRampInteractions),
        featureInfoHandlers: [],
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Orbis one way internals dev",
        target: onewayCollapse,
        map: map,
        getInteractions: (0, _genericInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/oneway-internals/restriction-statements-from-csv-dev-", (0, _parameters.getOnewayInternalMonths)()),
        style: (0, _genericInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Orbis one way internals prod",
        target: onewayCollapse,
        map: map,
        getInteractions: (0, _genericInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/oneway-internals/restriction-statements-from-csv-", (0, _parameters.getOnewayInternalMonths)()),
        style: (0, _genericInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "TT-Navigability internals dev",
        target: navCollapse,
        map: map,
        getInteractions: (0, _ttnavInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/ttnav-internals/restriction-statements-from-csv-dev-", 5),
        style: (0, _ttnavInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "TT-Navigability internals prod",
        target: navCollapse,
        map: map,
        getInteractions: (0, _ttnavInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/ttnav-internals/restriction-statements-from-csv-", 5),
        style: (0, _ttnavInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Orbis one way moderations",
        target: onewayCollapse,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "last_moderated_at",
        urls: [
            "/oneway-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "last_moderated_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "TT Navigability moderations",
        target: navCollapse,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "last_moderated_at",
        urls: [
            "/ttnav-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "last_moderated_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "OSM Navigability moderations",
        target: navCollapse,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "last_moderated_at",
        urls: [
            "/osmnav-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "last_moderated_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "DCW internals prod",
        target: dcwCollapse,
        map: map,
        getInteractions: (0, _genericInternal.getInteractions),
        sortField: "inserted_at",
        urls: (0, _fgblayersAndControls.getPreviousMonthsUrls)("/dcw-internals/dcw-statements-from-csv-", (0, _parameters.getDCWInternalMonths)()),
        style: (0, _genericInternal1.getStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "way_id",
            "inserted_at"
        ])),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
    (0, _fgblayersAndControls.addFGBLayerAndControl)({
        layerName: "Dual carriageway moderations",
        target: dcwCollapse,
        map: map,
        getInteractions: (0, _moderation.getModerationInteractions),
        sortField: "inserted_at",
        urls: [
            "/dcw-internals/moderations.fgb"
        ],
        style: (0, _moderation1.getModerationStyleNormal),
        featureInfoControl: featureInfoControl,
        transformFeature: (0, _fgblayersAndControls.customizeFeatureId)((0, _fgblayersAndControls.concatenateFeatureFields)([
            "id",
            "inserted_at"
        ])),
        minZoom: 10,
        settingConfigurationFn: (0, _fgblayersAndControls.enableIfAccessible),
        hoverStyleFunctions: [
            (0, _defaultHoverStyle.defaultHoverStyles)
        ]
    });
}
function getCollapsible(name) {
    const details = document.createElement("details");
    const summary = document.createElement("summary");
    summary.append(name);
    details.appendChild(summary);
    return details;
}

},{"../layers/interactions/navigability":"cDNub","../layers/interactions/gradient":"9xCCX","../layers/interactions/dualCarriageway":"lfOec","../layers/interactions/oneway":"hf098","../layers/style/dualCarriageway":"9qxyT","../layers/style/oneway":"htDSk","../layers/style/osmOneway":"gCrZW","../layers/style/gradient":"2PV5O","../layers/style/navigability":"9Xoog","../layers/style/lez":"9uDBc","../layers/interactions/lez":"laMBy","../layers/style/ramp":"5UuGC","../layers/style/lrtc":"aQdMD","../layers/interactions/ramp":"7Xj2g","../layers/interactions/lrtc":"lNcZF","../layers/style/curvature":"dM5mO","../layers/style/crosslink":"8WCJV","../layers/interactions/crosslink":"jYIV7","../layers/style/hdmap":"B4rqX","../layers/interactions/hdmap":"hMgEt","../layers/style/hdlaneborder":"1JESb","../layers/interactions/genericInternal":"k6wDA","../layers/style/genericInternal":"ewcqg","../layers/interactions/ttnavInternal":"aoM2a","../layers/style/ttnavInternal":"ktwaq","../layers/interactions/moderation":"2HC98","../layers/style/moderation":"6mNqw","./WFSLayersAndControls":"hGnEU","./FGBLayersAndControls":"kFPww","../parameters/parameters":"7yrJ4","../layers/CrosslinkHoverLayer":"aqJPu","../layers/featureinfohandlers/CrosslinkLayerHandler":"cmRGt","../layers/style/hover/defaultHoverStyle":"7BhHW","../layers/style/hover/drivingDirectionHoverStyle":"2saRO","../layers/style/hover/curvatureHoverStyle":"dmien","../layers/interactions/hdlaneborder":"8o9Ty","../layers/style/hdlanefunction":"8RbG5","../layers/interactions/hdlanefunction":"6WO6f","../layers/style/hdLaneRestriction":"fX2Ql","../layers/interactions/hdLaneRestriction":"bssof","../layers/interactions/curvature":"4OXTY","../layers/style/hdLaneWidth":"8bVY4","../layers/interactions/hdLaneWidth":"dhU0y","../layers/style/osmLanesNorm":"bIHM4","../layers/interactions/osmLanesNorm":"jevy1","../layers/style/controlledAccess":"2pw1E","../layers/interactions/controlledAccess":"1oi5n","../layers/addfeaturehandlers/CurvatureAtJunctionArcHandler":"l7M67","../layers/addfeaturehandlers/CurvatureLinearHandler":"1rcYN","../layers/addfeaturehandlers/CrosslinkCoverageHandler":"bPJbb","../layers/style/curvatureAtJunction":"dIuFs","../layers/interactions/curvatureAtJunction":"gshhL","../layers/style/sdLaneRestriction":"blYI9","../layers/interactions/sdLaneRestriction":"fsTm2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cDNub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavigabilityInteractions", ()=>getNavigabilityInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _navigability = require("../style/navigability");
function getNavigabilityInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _navigability.getNavigabilityStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _navigability.getNavigabilityStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/navigability":"9Xoog","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9Xoog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavigabilityStyleNormal", ()=>getNavigabilityStyleNormal);
parcelHelpers.export(exports, "getNavigabilityStyleClick", ()=>getNavigabilityStyleClick);
parcelHelpers.export(exports, "getNavigabilityStyleHover", ()=>getNavigabilityStyleHover);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _node = require("./node");
var _propertyExtraction = require("./propertyExtraction");
function getNavigabilityStyleNormal(feature) {
    return getNavigabilityColorStyle(feature).concat((0, _node.getNodeStyleNormal)(feature));
}
function getNavigabilityStyleClick(feature) {
    return getNavigabilityColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getNavigabilityStyleHover(feature) {
    return getNavigabilityColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature));
}
function getNavigabilityColorStyle(feature, click, hover) {
    let color, width;
    const orbisNavigability = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-navigability");
    const osmHighway = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-highway");
    if (osmHighway === undefined) {
        color = "black";
        width = 1;
    } else if (!(0, _supportedHighwayTypes.NAVIGABILITY_HIGHWAY_TYPES).includes(osmHighway)) {
        color = "grey";
        width = 1;
    } else if (orbisNavigability === "prohibited") {
        color = "#786F80";
        width = 3;
    } else if (orbisNavigability === "closed") {
        color = "red";
        width = 3;
    } else if (orbisNavigability === "no_through") {
        color = "orange";
        width = 3;
    } else if (orbisNavigability === "unknown") {
        color = "blue";
        width = 3;
    } else if (orbisNavigability === "open") {
        color = "green";
        width = 3;
    } else {
        color = "lightgreen";
        width = 1;
    }
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","./node":"1eDKT","./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lfOec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDualCarriagewayInteractions", ()=>getDualCarriagewayInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _dualCarriageway = require("../style/dualCarriageway");
function getDualCarriagewayInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _dualCarriageway.getDualCarriagewayStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _dualCarriageway.getDualCarriagewayStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/dualCarriageway":"9qxyT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9qxyT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDualCarriagewayStyleNormal", ()=>getDualCarriagewayStyleNormal);
parcelHelpers.export(exports, "getDualCarriagewayStyleClick", ()=>getDualCarriagewayStyleClick);
parcelHelpers.export(exports, "getDualCarriagewayStyleHover", ()=>getDualCarriagewayStyleHover);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _node = require("./node");
var _propertyExtraction = require("./propertyExtraction");
function getDualCarriagewayStyleNormal(feature) {
    return getDualCarriagewayColorStyle(feature).concat((0, _node.getNodeStyleNormal)(feature));
}
function getDualCarriagewayStyleClick(feature) {
    return getDualCarriagewayColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getDualCarriagewayStyleHover(feature) {
    return getDualCarriagewayColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature, true, false));
}
function getDualCarriagewayColorStyle(feature, click, hover) {
    let color, width;
    const orbisDualCarriageway = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-dual_carriageway");
    const orbisDualCarriagewayIsLR = orbisDualCarriageway !== undefined && orbisDualCarriageway.includes("#");
    const osmHighway = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-highway");
    let lineDash = null;
    if (osmHighway === undefined) color = "black";
    else if (!(0, _supportedHighwayTypes.DUAL_CARRIAGEWAY_HIGHWAY_TYPES).includes(osmHighway)) color = "grey";
    else if (orbisDualCarriageway === "yes") color = "green";
    else if (orbisDualCarriagewayIsLR) color = "violet";
    else color = "lightgreen";
    if (orbisDualCarriageway === "yes") width = 3;
    else if (orbisDualCarriagewayIsLR) {
        width = 2;
        lineDash = [
            1,
            3
        ];
    } else width = 1;
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: width * 2,
                lineDash: lineDash
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2,
                lineDash: lineDash
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width,
                lineDash: lineDash
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","./node":"1eDKT","./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gCrZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOsmOnewayStyleNormal", ()=>getOsmOnewayStyleNormal);
parcelHelpers.export(exports, "getOnewayStyleClick", ()=>getOnewayStyleClick);
parcelHelpers.export(exports, "getOnewayStyleHover", ()=>getOnewayStyleHover);
parcelHelpers.export(exports, "getArrowStyle", ()=>getArrowStyle);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _node = require("./node");
var _propertyExtraction = require("./propertyExtraction");
function getOsmOnewayStyleNormal(feature) {
    return getOnewayColorStyle(feature).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleNormal)(feature));
}
function getOnewayStyleClick(feature) {
    return getOnewayColorStyle(feature, true, false).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleClick)(feature));
}
function getOnewayStyleHover(feature) {
    return getOnewayColorStyle(feature, false, true).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleHover)(feature));
}
function getOnewayColorStyle(feature, click, hover) {
    let color;
    const osmOneway = (0, _propertyExtraction.getPropertyEndingWithExcludingLayer7)(feature, "-oneway");
    const osmHighway = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-highway");
    const osmJunction = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-junction");
    if (osmHighway === undefined) color = "black";
    else if (!(0, _supportedHighwayTypes.ONEWAY_HIGHWAY_TYPES).includes(osmHighway)) color = "grey";
    else if (osmHighway === "motorway" && osmOneway === undefined) color = "green";
    else if (osmOneway === "no") color = "blue";
    else if ((osmJunction === "roundabout" || osmJunction === "circular") && osmOneway === undefined) color = "green";
    else if (osmOneway === "yes") color = "green";
    else if (osmOneway === "-1") color = "cyan";
    else color = "blue";
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 6
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: 4
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: 8
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 4
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 2
            })
        })
    ];
}
function getArrowStyle(feature) {
    const osmOneway = (0, _propertyExtraction.getPropertyEndingWithExcludingLayer7)(feature, "-oneway");
    const styles = [];
    if (typeof feature.getGeometry().forEachSegment === "function") feature.getGeometry().forEachSegment(function(start, end) {
        const mid = [
            (start[0] + end[0]) / 2,
            (start[1] + end[1]) / 2
        ];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);
        // arrows
        if (osmOneway === "yes") styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation,
                color: "green",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
        if (osmOneway === "-1") styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation + Math.PI,
                color: "green",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
    });
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","ol/geom/Point":"95T6m","./node":"1eDKT","./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9uDBc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEmissionRegulationStyleNormal", ()=>getEmissionRegulationStyleNormal);
parcelHelpers.export(exports, "getEmissionRegulationStyleClick", ()=>getEmissionRegulationStyleClick);
parcelHelpers.export(exports, "getEmissionRegulationStyleHover", ()=>getEmissionRegulationStyleHover);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _node = require("./node");
function getEmissionRegulationStyleNormal(feature) {
    return getEmissionRegulationColorStyle(feature).concat((0, _node.getNodeStyleNormal)(feature));
}
function getEmissionRegulationStyleClick(feature) {
    return getEmissionRegulationColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getEmissionRegulationStyleHover(feature) {
    return getEmissionRegulationColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature));
}
function getEmissionRegulationColorStyle(feature, click, hover) {
    let color, width;
    const emissionRegulation = findValueByKeyEndingWith(feature.getProperties(), "/emission_regulation");
    const highway = findValueByKeyEndingWith(feature.getProperties(), "/highway");
    if (highway === undefined) {
        color = "black";
        width = 1;
    } else if (!(0, _supportedHighwayTypes.EMISSION_REGULATION_HIGHWAY_TYPES).includes(highway)) {
        color = "grey";
        width = 1;
    } else if (emissionRegulation === "yes") {
        color = "#063970"; // dark blue
        width = 3;
    } else {
        color = "#abdbe3"; // light blue
        width = 1;
    }
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "#eab676",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function findValueByKeyEndingWith(obj, suffix) {
    const key = Object.keys(obj).find((key)=>key.endsWith(suffix));
    return obj[key];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","./node":"1eDKT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"laMBy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEmissionRegulationInteractions", ()=>getEmissionRegulationInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _lez = require("../style/lez");
function getEmissionRegulationInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _lez.getEmissionRegulationStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _lez.getEmissionRegulationStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/lez":"9uDBc","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5UuGC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRampStyleNormal", ()=>getRampStyleNormal);
parcelHelpers.export(exports, "getRampStyleClick", ()=>getRampStyleClick);
parcelHelpers.export(exports, "getRampStyleHover", ()=>getRampStyleHover);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _node = require("./node");
function getRampStyleNormal(feature) {
    return getRampColorStyle(feature).concat((0, _node.getNodeStyleNormal)(feature));
}
function getRampStyleClick(feature) {
    return getRampColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getRampStyleHover(feature) {
    return getRampColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature));
}
function getRampColorStyle(feature, click, hover) {
    let color, width;
    const ramp = findValueByKeyEndingWith(feature.getProperties(), "ramp");
    const highway = findValueByKeyEndingWith(feature.getProperties(), "highway");
    if (highway === undefined) {
        color = "black";
        width = 1;
    } else if (!(0, _supportedHighwayTypes.RAMP_HIGHWAY_TYPES).includes(highway)) {
        color = "grey";
        width = 1;
    } else if (ramp === "yes") {
        color = "#CD2C58"; // cardinal red
        width = 3;
    } else {
        color = "#abdbe3"; // light blue
        width = 1;
    }
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "#eab676",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function findValueByKeyEndingWith(obj, suffix) {
    const key = Object.keys(obj).find((key)=>key.endsWith(suffix));
    return obj[key];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","./node":"1eDKT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aQdMD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLrtcStyleNormal", ()=>getLrtcStyleNormal);
parcelHelpers.export(exports, "getLrtcStyleClick", ()=>getLrtcStyleClick);
parcelHelpers.export(exports, "getLrtcStyleHover", ()=>getLrtcStyleHover);
var _style = require("ol/style");
var _geom = require("ol/geom");
var _node = require("./node");
var _propertyExtraction = require("./propertyExtraction");
function getLrtcStyleNormal(feature) {
    return getLrtcColorStyle(feature, false, false).concat((0, _node.getNodeStyleNormal)(feature));
}
function getLrtcStyleClick(feature) {
    return getLrtcColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getLrtcStyleHover(feature) {
    return getLrtcColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature));
}
function buildExtentMultiPoint(feature) {
    const geom = feature.getGeometry && feature.getGeometry();
    if (!geom || !geom.getFlatCoordinates) return undefined;
    const flatCoordinates = geom.getFlatCoordinates();
    if (!Array.isArray(flatCoordinates) || flatCoordinates.length < 2) return undefined;
    // Use original flatCoordinates as MultiPoint vertices (no extent / bbox)
    const points = [];
    for(let i = 0; i < flatCoordinates.length; i += 2)points.push([
        flatCoordinates[i],
        flatCoordinates[i + 1]
    ]);
    return new (0, _geom.MultiPoint)(points);
}
function getLrtcColorStyle(feature, click, hover) {
    let color, width;
    let hdmapType = (0, _propertyExtraction.getProperty)(feature, "hdmap");
    let laneRelation = (0, _propertyExtraction.getProperty)(feature, "lane_relation");
    if (laneRelation === "crossing") {
        color = "orange";
        width = 6;
    } else if (hdmapType !== undefined && hdmapType === "lane_trajectory_line") {
        color = "green";
        width = 2;
    } else {
        color = "grey";
        width = 1;
    }
    if (hover || click) width = 8;
    const styles = [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
    if ((0, _propertyExtraction.getPropertyEndingWith)(feature, "-type") === "lane_relation") {
        // Visualize original flatCoordinates
        const multiPoint = buildExtentMultiPoint(feature);
        if (multiPoint) {
            let pointRadius = 3;
            if (hover || click) pointRadius = 5;
            styles.push(new (0, _style.Style)({
                geometry: multiPoint,
                image: new (0, _style.Circle)({
                    radius: pointRadius,
                    fill: new (0, _style.Fill)({
                        color: click ? "orange" : hover ? "yellow" : "white"
                    }),
                    stroke: new (0, _style.Stroke)({
                        color: "blue",
                        width: 1
                    })
                })
            }));
        }
    }
    return styles;
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/geom":[["MultiPoint","jiQtb","default"]],"./node":"1eDKT","./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Xj2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRampInteractions", ()=>getRampInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _ramp = require("../style/ramp");
function getRampInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _ramp.getRampStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _ramp.getRampStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/ramp":"5UuGC","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lNcZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLrtcInteractions", ()=>getLrtcInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _lrtc = require("../style/lrtc");
function getLrtcInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _lrtc.getLrtcStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _lrtc.getLrtcStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/lrtc":"aQdMD","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1JESb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneBorderStyleNormal", ()=>getHDLaneBorderStyleNormal);
parcelHelpers.export(exports, "getHDLaneBorderStyleClick", ()=>getHDLaneBorderStyleClick);
parcelHelpers.export(exports, "getHDLaneBorderStyleHover", ()=>getHDLaneBorderStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
var _offsetLineString = require("./util/offsetLineString");
function getHDLaneBorderStyleNormal(feature, resolution) {
    return getHDLaneBorderColorStyle(feature, false, false, resolution);
}
function getHDLaneBorderStyleClick(feature, resolution) {
    return getHDLaneBorderColorStyle(feature, true, false, resolution);
}
function getHDLaneBorderStyleHover(feature, resolution) {
    return getHDLaneBorderColorStyle(feature, false, true, resolution);
}
function getHDLaneBorderColorStyle(feature, click, hover, resolution) {
    const tags = (0, _propertyExtraction.extractTags)(feature);
    let hdmapType = tags.hdMap;
    if (hdmapType !== undefined) {
        if (hdmapType !== "lane_border") return;
    }
    let type = feature.get("type");
    if (type === "ORBIS_RELATION") return;
    let laneBorder = tags.laneBorder;
    let backgroundWidth = 6;
    if (hover || click) backgroundWidth = 10;
    if (laneBorder === undefined) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "lightgrey",
                width: 1,
                lineCap: "butt"
            })
        })
    ];
    if (laneBorder.includes("double_solid")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth,
                lineCap: "butt"
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "yellow",
                width: 3,
                lineCap: "butt"
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: 1,
                lineCap: "butt"
            })
        })
    ];
    if (laneBorder.includes("solid_dashed")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth + 4,
                lineCap: "butt"
            })
        }),
        // left
        new (0, _style.Style)({
            geometry: (0, _offsetLineString.shiftLeft)(feature, resolution, 2),
            stroke: longDashStroke,
            lineCap: "butt"
        }),
        // right
        new (0, _style.Style)({
            geometry: (0, _offsetLineString.shiftRight)(feature, resolution, 2),
            stroke: whiteLineStroke,
            lineCap: "butt"
        })
    ];
    if (laneBorder.includes("dashed_solid")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth + 4,
                lineCap: "butt"
            })
        }),
        // left
        new (0, _style.Style)({
            geometry: (0, _offsetLineString.shiftLeft)(feature, resolution, 2),
            stroke: whiteLineStroke,
            lineCap: "butt"
        }),
        // right
        new (0, _style.Style)({
            geometry: (0, _offsetLineString.shiftRight)(feature, resolution, 2),
            stroke: longDashStroke,
            lineCap: "butt"
        })
    ];
    if (laneBorder.includes("solid")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth,
                lineCap: "butt"
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: 2,
                lineCap: "butt"
            })
        })
    ];
    if (laneBorder.includes("dashed")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth,
                lineCap: "butt"
            })
        }),
        new (0, _style.Style)({
            stroke: shortDashedStroke
        })
    ];
    if (laneBorder.includes("road_border")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "grey",
                width: backgroundWidth - 2,
                lineCap: "butt"
            })
        })
    ];
    if (laneBorder.includes("virtual")) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "lightgrey",
                width: 2,
                lineCap: "butt"
            })
        })
    ];
}
const longDashStroke = new (0, _style.Stroke)({
    color: "white",
    lineDash: [
        10,
        25
    ],
    width: 2,
    lineCap: "butt"
});
const whiteLineStroke = new (0, _style.Stroke)({
    color: "white",
    width: 2,
    lineCap: "butt"
});
const shortDashedStroke = new (0, _style.Stroke)({
    color: "white",
    lineDash: [
        10,
        5
    ],
    width: 2,
    lineCap: "butt"
});

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","./util/offsetLineString":"aZ5xq","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aZ5xq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shiftLeft", ()=>shiftLeft);
parcelHelpers.export(exports, "shiftRight", ()=>shiftRight);
var _geom = require("ol/geom");
// A helper function to compute an offset LineString.
// "offset" is the distance you want to shift (positive value shifts to the left).
function offsetLineString(lineString, offset) {
    const coords = lineString.getCoordinates();
    const offsetCoords = [];
    for(let i = 0; i < coords.length; i++){
        const p = coords[i];
        let angle;
        if (i === 0) {
            // For the first vertex, use the angle of the first segment.
            const p2 = coords[i + 1];
            angle = Math.atan2(p2[1] - p[1], p2[0] - p[0]);
        } else if (i === coords.length - 1) {
            // For the last vertex, use the angle of the previous segment.
            const p1 = coords[i - 1];
            angle = Math.atan2(p[1] - p1[1], p[0] - p1[0]);
        } else {
            // For vertices in the middle, average the angles of the previous and next segments.
            const p1 = coords[i - 1];
            const p2 = coords[i + 1];
            const angle1 = Math.atan2(p[1] - p1[1], p[0] - p1[0]);
            const angle2 = Math.atan2(p2[1] - p[1], p2[0] - p[0]);
            angle = (angle1 + angle2) / 2;
        }
        // Compute the perpendicular (left) offset.
        const offsetX = offset * Math.cos(angle - Math.PI / 2);
        const offsetY = offset * Math.sin(angle - Math.PI / 2);
        offsetCoords.push([
            p[0] + offsetX,
            p[1] + offsetY
        ]);
    }
    return new (0, _geom.LineString)(offsetCoords);
}
function shiftLeft(feature, resolution, pixelOffset) {
    var geom = feature.getGeometry();
    if (geom.getType() === "LineString") {
        // Adjust the second parameter to set how far left you want the line shifted.
        const realOffset = pixelOffset * resolution;
        return offsetLineString(geom, -realOffset);
    }
    return geom;
}
function shiftRight(feature, resolution, pixelOffset) {
    var geom = feature.getGeometry();
    if (geom.getType() === "LineString") {
        // Adjust the second parameter to set how far left you want the line shifted.
        const realOffset = pixelOffset * resolution;
        return offsetLineString(geom, realOffset);
    }
    return geom;
}

},{"ol/geom":[["LineString","223qD","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k6wDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractions", ()=>getInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _genericInternal = require("../style/genericInternal");
function getInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        multi: true,
        style: function(feature) {
            return (0, _genericInternal.getStyleClick)(feature);
        },
        hitTolerance: 5
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
        layer.changed();
    });
    const hoverSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.pointerMove),
        style: function(feature) {
            return (0, _genericInternal.getStyleHover)(feature);
        }
    });
    hoverSelect.on("select", function() {
        layer.changed();
    });
    return [
        clickSelect,
        hoverSelect
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/genericInternal":"ewcqg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ewcqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleNormal", ()=>getStyleNormal);
parcelHelpers.export(exports, "getStyleClick", ()=>getStyleClick);
parcelHelpers.export(exports, "getStyleHover", ()=>getStyleHover);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
function getStyleNormal(feature) {
    return getColorStyle(feature);
}
function getStyleClick(feature) {
    return getColorStyle(feature, true, false).concat(getArrowStyle(feature));
}
function getStyleHover(feature) {
    return getColorStyle(feature, false, true).concat(getArrowStyle(feature));
}
function getColorStyle(feature, click, hover) {
    let color, width;
    color = "grey";
    width = 3;
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function getArrowStyle(feature) {
    const styles = [];
    if (typeof feature.getGeometry().forEachSegment === "function") feature.getGeometry().forEachSegment(function(start, end) {
        const mid = [
            (start[0] + end[0]) / 2,
            (start[1] + end[1]) / 2
        ];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);
        // arrows
        styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation,
                color: "grey",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
    });
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/geom/Point":"95T6m","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aoM2a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractions", ()=>getInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _ttnavInternal = require("../style/ttnavInternal");
function getInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        multi: true,
        style: function(feature) {
            return (0, _ttnavInternal.getStyleClick)(feature);
        },
        hitTolerance: 5
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
        layer.changed();
    });
    const hoverSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.pointerMove),
        style: function(feature) {
            return (0, _ttnavInternal.getStyleHover)(feature);
        }
    });
    hoverSelect.on("select", function() {
        layer.changed();
    });
    return [
        clickSelect,
        hoverSelect
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/ttnavInternal":"ktwaq","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ktwaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleNormal", ()=>getStyleNormal);
parcelHelpers.export(exports, "getStyleClick", ()=>getStyleClick);
parcelHelpers.export(exports, "getStyleHover", ()=>getStyleHover);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
function getStyleNormal(feature) {
    return getColorStyle(feature);
}
function getStyleClick(feature) {
    return getColorStyle(feature, true, false).concat(getArrowStyle(feature));
}
function getStyleHover(feature) {
    return getColorStyle(feature, false, true).concat(getArrowStyle(feature));
}
function getColorStyle(feature, click, hover) {
    let color, width;
    color = "violet";
    width = 3;
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "darkviolet",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function getArrowStyle(feature) {
    const styles = [];
    if (typeof feature.getGeometry().forEachSegment === "function") feature.getGeometry().forEachSegment(function(start, end) {
        const mid = [
            (start[0] + end[0]) / 2,
            (start[1] + end[1]) / 2
        ];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);
        // arrows
        styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation,
                color: "grey",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
    });
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/geom/Point":"95T6m","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2HC98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModerationInteractions", ()=>getModerationInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _moderation = require("../style/moderation");
function getModerationInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        multi: true,
        style: function(feature) {
            return (0, _moderation.getModerationStyleClick)(feature);
        },
        hitTolerance: 5
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
        layer.changed();
    });
    const hoverSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.pointerMove),
        style: function(feature) {
            return (0, _moderation.getModerationStyleHover)(feature);
        }
    });
    hoverSelect.on("select", function() {
        layer.changed();
    });
    return [
        clickSelect,
        hoverSelect
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/moderation":"6mNqw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6mNqw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModerationStyleNormal", ()=>getModerationStyleNormal);
parcelHelpers.export(exports, "getModerationStyleClick", ()=>getModerationStyleClick);
parcelHelpers.export(exports, "getModerationStyleHover", ()=>getModerationStyleHover);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
function getModerationStyleNormal(feature) {
    return getColorStyle(feature);
}
function getModerationStyleClick(feature) {
    return getColorStyle(feature, true, false).concat(getArrowStyle(feature));
}
function getModerationStyleHover(feature) {
    return getColorStyle(feature, false, true).concat(getArrowStyle(feature));
}
function getColorStyle(feature, click, hover) {
    let color, width;
    let clickColor;
    if (feature.get("statement") !== undefined && feature.get("statement") !== "" || feature.get("statement_value") !== undefined && feature.get("statement_value") !== "") {
        color = "purple";
        clickColor = "yellow";
    } else {
        color = "#CF9FFF"; // light violet
        clickColor = "#FFFF8F"; // light yellow
    }
    width = 3;
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: clickColor,
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function getArrowStyle(feature) {
    const styles = [];
    if (typeof feature.getGeometry().forEachSegment === "function") feature.getGeometry().forEachSegment(function(start, end) {
        const mid = [
            (start[0] + end[0]) / 2,
            (start[1] + end[1]) / 2
        ];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);
        // arrows
        styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation,
                color: "grey",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
    });
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/geom/Point":"95T6m","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7yrJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOnewayInternalMonths", ()=>getOnewayInternalMonths);
parcelHelpers.export(exports, "getHDLanerestrictionInternalMonths", ()=>getHDLanerestrictionInternalMonths);
parcelHelpers.export(exports, "getSDLanerestrictionInternalMonths", ()=>getSDLanerestrictionInternalMonths);
parcelHelpers.export(exports, "getDCWInternalMonths", ()=>getDCWInternalMonths);
function getOnewayInternalMonths() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const internalMonths = urlParams.get("oneway_internal_months");
    if (internalMonths != null) return internalMonths;
    return "6";
}
function getHDLanerestrictionInternalMonths() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const internalMonths = urlParams.get("hdlaneres_internal_months");
    if (internalMonths != null) return internalMonths;
    return "6";
}
function getSDLanerestrictionInternalMonths() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const internalMonths = urlParams.get("sdlaneres_internal_months");
    if (internalMonths != null) return internalMonths;
    return "6";
}
function getDCWInternalMonths() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const internalMonths = urlParams.get("dcw_internal_months");
    if (internalMonths != null) return internalMonths;
    return "6";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dmien":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curvatureHoverStylesGenesis", ()=>curvatureHoverStylesGenesis);
parcelHelpers.export(exports, "curvatureHoverStylesOrbisSD", ()=>curvatureHoverStylesOrbisSD);
parcelHelpers.export(exports, "curvatureHoverStylesOrbisHD", ()=>curvatureHoverStylesOrbisHD);
parcelHelpers.export(exports, "curvatureAtJunctionHoverStylesOrbisSD", ()=>curvatureAtJunctionHoverStylesOrbisSD);
parcelHelpers.export(exports, "curvatureHoverStyles", ()=>curvatureHoverStyles);
var _proj = require("ol/proj");
var _lineString = require("ol/geom/LineString");
var _lineStringDefault = parcelHelpers.interopDefault(_lineString);
var _style = require("ol/style");
var _circle = require("ol/geom/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _color = require("ol/color");
var _colorScale = require("../util/colorScale");
var _curvature = require("../curvature");
var _arcOverlapOffset = require("../util/arcOverlapOffset");
var _propertyExtraction = require("../propertyExtraction");
function curvatureHoverStylesGenesis() {
    return curvatureHoverStyles();
}
function curvatureHoverStylesOrbisSD() {
    return curvatureHoverStyles();
}
function curvatureHoverStylesOrbisHD() {
    return curvatureHoverStyles();
}
function curvatureAtJunctionHoverStylesOrbisSD() {
    return curvatureHoverStyles();
}
function curvatureCircleStyles(curvature, coordinates, colorLike) {
    const curvatureAbsolute = Math.abs(curvature);
    const radius = 10000 / curvatureAbsolute;
    const end = coordinates[coordinates.length - 1];
    const circleCoordinates = [
        end[0],
        end[1]
    ];
    const lonLat = (0, _proj.toLonLat)(circleCoordinates);
    const lsLonLat = coordinates.map((coord)=>(0, _proj.toLonLat)(coord));
    const midLonLat = movePerpendicular(lonLat, lsLonLat, radius, curvature < 0);
    const startMercator = circleCoordinates;
    const midMercator = (0, _proj.fromLonLat)(midLonLat);
    const distanceAB = new (0, _lineStringDefault.default)([
        startMercator,
        midMercator
    ]).getLength();
    const styles = [];
    const color = (0, _color.asArray)(colorLike);
    const colorTransparent = color.slice();
    colorTransparent[3] = 0.3;
    styles.push(new (0, _style.Style)({
        geometry: new (0, _circleDefault.default)(midMercator, distanceAB),
        fill: new (0, _style.Fill)({
            color: colorTransparent
        }),
        stroke: new (0, _style.Stroke)({
            color: color,
            width: 2
        })
    }));
    return styles;
}
function curvatureHoverStyles() {
    return function(feature, resolution) {
        //3857
        const coordinates = (0, _arcOverlapOffset.applyOverlapOffset)(feature.getGeometry().getCoordinates(), feature, resolution);
        let curvature = feature.get("orbis-curvature:linear");
        if (curvature === undefined) curvature = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-curvature:linear");
        if (curvature === undefined) curvature = feature.get("curvature_at_junction");
        // Guard: draw no circle unless curvature is a finite, non-zero number. A
        // non-numeric value (e.g. an LR-step-encoded "a#b" string) would otherwise reach
        // colorForSpeed as NaN and crash the spectral interpolation.
        const curvNum = Number(curvature);
        if (!Number.isFinite(curvNum) || curvNum === 0) return [];
        const [r, g, b] = (0, _colorScale.colorForSpeed)((0, _curvature.maxSpeedFromCurvature)(curvNum));
        return curvatureCircleStyles(curvNum, coordinates, `rgb(${r},${g},${b})`);
    };
}
function movePerpendicular(lonLat, coordinates, distance, isNegative) {
    const [longitude, latitude] = lonLat;
    const converter = new (0, _orbisLrSdk.CoordConverterGaussKruger)(longitude);
    const [lonGK, latGK] = converter.convertWgsToGaussKrueger(longitude, latitude);
    // Find the segment containing the point
    let closestPrev = null;
    let closestNext = null;
    for(let i = 0; i < coordinates.length - 1; i++){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        if (isPointOnSegment(start, end, lonLat)) {
            closestPrev = start;
            closestNext = end;
            break;
        }
    }
    if (!closestPrev || !closestNext) throw new Error("Point is not on the linestring");
    const closestPrevGK = converter.convertWgsToGaussKrueger(closestPrev[0], closestPrev[1]);
    const closestNextGK = converter.convertWgsToGaussKrueger(closestNext[0], closestNext[1]);
    // Calculate the angle of the line segment
    const dx = closestNextGK[0] - closestPrevGK[0];
    const dy = closestNextGK[1] - closestPrevGK[1];
    const angle = Math.atan2(dy, dx); // Angle in radians
    // Calculate the angle for perpendicular direction
    const perpendicularAngle = angle + Math.PI / 2; // 90 degrees in radians
    // Calculate new coordinates
    let newLongitudeGK = lonGK + distance * Math.cos(perpendicularAngle);
    let newLatitudeGK = latGK + distance * Math.sin(perpendicularAngle);
    if (isNegative) {
        newLongitudeGK = lonGK - distance * Math.cos(perpendicularAngle);
        newLatitudeGK = latGK - distance * Math.sin(perpendicularAngle);
    }
    // Return new lonLat
    return converter.convertGaussKruegerToWgs(newLongitudeGK, newLatitudeGK);
}
function isPointOnSegment(start, end, point) {
    const d1 = distance(start, point);
    const d2 = distance(end, point);
    const segmentLength = distance(start, end);
    // Check if point is within a small tolerance of the segment
    const tolerance = 0.0001; // Adjust as needed
    return Math.abs(d1 + d2 - segmentLength) < tolerance;
}
function distance(coord1, coord2) {
    return Math.sqrt(Math.pow(coord2[0] - coord1[0], 2) + Math.pow(coord2[1] - coord1[1], 2));
}

},{"ol/proj":"gN0IK","ol/geom/LineString":"223qD","ol/style":[["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/geom/Circle":"13EZt","@orbis-lr-sdk/orbis-lr-sdk":"04bfk","ol/color":"jC16r","../util/colorScale":"dOPOB","../curvature":"dM5mO","../util/arcOverlapOffset":"3JNUC","../propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3JNUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERLAP_OFFSET_PX", ()=>OVERLAP_OFFSET_PX);
/**
 * Offset `coords` for display if `feature` was tagged as overlapping; else
 * return `coords` unchanged. Shared by the normal style and the hover circle.
 */ parcelHelpers.export(exports, "applyOverlapOffset", ()=>applyOverlapOffset);
var _polylineMjs = require("./polyline.mjs");
const OVERLAP_OFFSET_PX = 7;
function applyOverlapOffset(coords, feature, resolution) {
    const overlapOffset = feature.get("overlap-offset");
    if (typeof overlapOffset !== "number" || !resolution) return coords;
    // Only transform the full arc polyline — never a short probe such as the hover
    // tangent (a 2-point line near the cursor that copies the source arc's props,
    // including the node tags). Snapping that to the far-away junction nodes would
    // blow up the hover curvature circle. Every real arc has many vertices — curved
    // ones are sampled densely and straight ones are densified at construction
    // (see STRAIGHT_ARC_POINTS in curvatureArcGeometry.js) precisely so this offset
    // applies to them too.
    if (coords.length < 3) return coords;
    // Pull the arc onto the group's shared junction nodes (its raw endpoints drift
    // ~0.5m from its pair partner's, so this keeps the pair symmetric about a common
    // centerline), then shift it sideways by a constant parallel offset so the pair
    // runs side by side the whole length.
    const startNode = feature.get("overlap-start-node");
    const endNode = feature.get("overlap-end-node");
    const snapped = startNode && endNode ? (0, _polylineMjs.snapEndpoints)(coords, startNode, endNode) : coords;
    return (0, _polylineMjs.offsetPolyline)(snapped, overlapOffset * OVERLAP_OFFSET_PX * resolution);
}

},{"./polyline.mjs":"iGzK1","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8o9Ty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneBorderInteractions", ()=>getHDLaneBorderInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdlaneborder = require("../style/hdlaneborder");
function getHDLaneBorderInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: (0, _hdlaneborder.getHDLaneBorderStyleClick)
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: (0, _hdlaneborder.getHDLaneBorderStyleHover)
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdlaneborder":"1JESb","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8RbG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneFunctionStyleNormal", ()=>getHDLaneFunctionStyleNormal);
parcelHelpers.export(exports, "getHDLaneFunctionStyleClick", ()=>getHDLaneFunctionStyleClick);
parcelHelpers.export(exports, "getHDLaneFunctionStyleHover", ()=>getHDLaneFunctionStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
function getHDLaneFunctionStyleNormal(feature) {
    return getHDLaneFunctionColorStyle(feature);
}
function getHDLaneFunctionStyleClick(feature) {
    return getHDLaneFunctionColorStyle(feature, true, false);
}
function getHDLaneFunctionStyleHover(feature) {
    return getHDLaneFunctionColorStyle(feature, false, true);
}
function getHDLaneFunctionColorStyle(feature, click, hover) {
    let color, width, backgroundColor, backgroundWidth;
    let lineDash = null;
    const tags = (0, _propertyExtraction.extractTags)(feature);
    if (tags.hdMap === undefined || tags.hdMap !== "lane_center_line" && tags.hdMap !== "lane_trajectory_line") return [];
    backgroundColor = "white";
    if (tags.laneFunction !== undefined) {
        if (tags.laneFunction === "drivable") color = "green";
        else if (tags.laneFunction === "shoulder") color = "white";
        else color = "red";
        width = 2;
    } else {
        color = "green";
        width = 2;
    }
    if (tags.hovLane !== undefined && tags.hovLane === "yes" || tags.hov !== undefined && tags.hov === "yes") lineDash = [
        10,
        5
    ];
    if (tags.vehicleRestrictionBus !== undefined || tags.vehicleRestrictionHGV !== undefined || tags.vehicleRestrictionMotorVehicle !== undefined && tags.vehicleRestrictionMotorVehicle !== "yes" || tags.vehicleRestrictionMotorcar !== undefined || tags.vehicleRestrictionPSV !== undefined || tags.vehicleRestrictionTaxi !== undefined) {
        backgroundColor = "orange";
        backgroundWidth = 6;
    }
    if (hover || click) backgroundWidth = 8;
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width,
                lineDash: lineDash
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6WO6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneFunctionInteractions", ()=>getHDLaneFunctionInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdlanefunction = require("../style/hdlanefunction");
function getHDLaneFunctionInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _hdlanefunction.getHDLaneFunctionStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _hdlanefunction.getHDLaneFunctionStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdlanefunction":"8RbG5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fX2Ql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneRestrictionStyleNormal", ()=>getHDLaneRestrictionStyleNormal);
parcelHelpers.export(exports, "getHDLaneRestrictionStyleClick", ()=>getHDLaneRestrictionStyleClick);
parcelHelpers.export(exports, "getHDLaneRestrictionStyleHover", ()=>getHDLaneRestrictionStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
var _stepSectionStyle = require("./util/stepSectionStyle");
function getHDLaneRestrictionStyleNormal(feature) {
    return getHDLaneRestrictionColorStyle(feature);
}
function getHDLaneRestrictionStyleClick(feature) {
    return getHDLaneRestrictionColorStyle(feature, true, false);
}
function getHDLaneRestrictionStyleHover(feature) {
    return getHDLaneRestrictionColorStyle(feature, false, true);
}
const HIDDEN = [
    new (0, _style.Style)({
        stroke: new (0, _style.Stroke)({
            color: "transparent",
            width: 0
        })
    })
];
// bus ==> maroon, hgv ==> purple, psv ==> blue, taxi ==> yellow, hov ==> orange,
// motor_vehicle restriction ==> darkgrey, else grey.
//
// `tags` here holds scalar values only: where a tag is step-encoded,
// styleBySection() has already resolved it to the value that applies to the
// section being drawn (or undefined where no section covers it).
function classifyHDLaneRestriction(tags) {
    if (tags.vehicleRestrictionBus === "yes") return {
        color: "maroon",
        width: 4,
        backgroundWidth: 6
    };
    if (tags.vehicleRestrictionHGV === "yes") return {
        color: "purple",
        width: 4,
        backgroundWidth: 6
    };
    if (tags.vehicleRestrictionPSV === "yes") return {
        color: "blue",
        width: 4,
        backgroundWidth: 6
    };
    if (tags.vehicleRestrictionTaxi === "yes") return {
        color: "yellow",
        width: 4,
        backgroundWidth: 6
    };
    if (tags.hovLane === "yes" || tags.hov === "yes") return {
        color: "orange",
        width: 4,
        backgroundWidth: 6
    };
    if (tags.vehicleRestrictionMotorVehicle !== undefined && tags.vehicleRestrictionMotorVehicle !== "yes") return {
        color: "darkgrey",
        width: 4,
        backgroundWidth: 6
    };
    return {
        color: "grey",
        width: 1,
        backgroundWidth: 2
    };
}
function getHDLaneRestrictionColorStyle(feature, click = false, hover = false) {
    const tags = (0, _propertyExtraction.extractTags)(feature);
    if (tags.hdMap !== "lane_center_line" && tags.hdMap !== "lane_trajectory_line") return HIDDEN;
    return (0, _stepSectionStyle.styleBySection)(feature, tags, classifyHDLaneRestriction, (descriptor, geometry)=>[
            new (0, _style.Style)({
                geometry: geometry,
                stroke: new (0, _style.Stroke)({
                    color: "white",
                    width: hover || click ? 6 : descriptor.backgroundWidth
                })
            }),
            new (0, _style.Style)({
                geometry: geometry,
                stroke: new (0, _style.Stroke)({
                    color: descriptor.color,
                    width: descriptor.width
                })
            })
        ]);
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","./util/stepSectionStyle":"8hjKE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8hjKE":[function(require,module,exports,__globalThis) {
// Adapter between LR *step* tag values and OpenLayers styling: decodes the
// sections with orbis-lr-sdk, works out the stretches over which every tag is
// constant (`stepSections.mjs`), and hands each stretch back to the caller as
// its own sliced geometry.
//
// Why per-section styles rather than one style per feature: a step tag such as
// `0-1000#yes;5000-7000#no` restricts only part of the lane. Colouring the
// whole feature from it would claim a restriction where there is none, and
// dropping it (what happened before — `"0-1000#yes" !== "yes"`) hid it
// entirely.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStepEncodedValue", ()=>(0, _stepSectionsMjs.isStepEncodedValue));
/**
 * Decode one step tag value into `{startCm, endCm, value}` sections. The SDK
 * needs the `:step` suffix on the key to pick the step interpolation — the WFS
 * hands us the decoded (suffix-less) key, so it is re-appended here.
 * @param {string} value
 * @returns {{startCm: number, endCm: number|null, value: string}[]}
 */ parcelHelpers.export(exports, "decodeStepSections", ()=>decodeStepSections);
/**
 * Style a feature per step section.
 *
 * `classify` turns a set of resolved (scalar) tag values into a plain
 * descriptor — colour, width, whatever the caller needs — and `toStyles` turns
 * that descriptor into OL styles. Splitting the two lets neighbouring sections
 * that happen to look the same be merged before any Style is built.
 *
 * When the feature carries no step-encoded tag (the common case) this is
 * exactly `toStyles(classify(tags), undefined)` — no slicing, no behaviour
 * change, and `undefined` tells the caller to leave `Style.geometry` alone so
 * OL uses the feature's own geometry.
 *
 * @param {import("ol/Feature").default} feature
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @param {(tags: Record<string, string|undefined>) => object} classify
 * @param {(descriptor: object, geometry: import("ol/geom/LineString").default|undefined) => import("ol/style/Style").default[]} toStyles
 * @returns {import("ol/style/Style").default[]}
 */ parcelHelpers.export(exports, "styleBySection", ()=>styleBySection);
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _util = require("../../../util");
var _lrDecoding = require("./lrDecoding");
var _stepSectionsMjs = require("./stepSections.mjs");
function decodeStepSections(value) {
    let chain;
    try {
        chain = (0, _lrDecoding.lrDecode)("section:step", value);
    } catch  {
        return [];
    }
    return chain.elements.map((element)=>({
            startCm: element.getStartDistance(),
            endCm: typeof element.getEndDistance === "function" ? element.getEndDistance() : null,
            value: element.getValue()
        }));
}
// OL re-runs style functions on every render frame, and both LR decoding and
// line slicing are O(vertices). Memoising them per feature keeps panning cheap.
// Only the *inputs* are cached — never the Style objects, which must stay fresh
// so normal/hover/click frames don't share one array.
const decodeCache = new WeakMap();
const sliceCache = new WeakMap();
function cached(cache, feature, key, compute) {
    let perFeature = cache.get(feature);
    if (!perFeature) {
        perFeature = new Map();
        cache.set(feature, perFeature);
    }
    if (!perFeature.has(key)) perFeature.set(key, compute());
    return perFeature.get(key);
}
function getLengthCm(feature) {
    const cached = feature.get("lengthCm");
    if (Number.isFinite(cached) && cached > 0) return cached;
    try {
        return (0, _orbisLrSdk.lengthOnPlaneCm)((0, _util.featureTo4326Geometry)(feature));
    } catch  {
        return 0;
    }
}
function styleBySection(feature, tags, classify, toStyles) {
    const wholeFeature = ()=>toStyles(classify(tags), undefined);
    const geometry = feature.getGeometry();
    if (!geometry || geometry.getType() !== "LineString") return wholeFeature();
    const sectionsByTag = {};
    const scalarTags = {
        ...tags
    };
    Object.keys(tags).forEach((name)=>{
        // The looser test: these callers pass enumerated restriction tags, so the
        // bare-offset form is unambiguously a step section here. See
        // isOffsetSectionedValue for why it isn't safe to widen globally.
        if (!(0, _stepSectionsMjs.isOffsetSectionedValue)(tags[name])) return;
        const sections = cached(decodeCache, feature, tags[name], ()=>decodeStepSections(tags[name]));
        if (sections.length === 0) return; // undecodable — leave it as a scalar
        sectionsByTag[name] = sections;
        // Outside its sections a step tag simply doesn't apply; the raw chain must
        // not leak into classify() as if it were a value.
        scalarTags[name] = undefined;
    });
    if (Object.keys(sectionsByTag).length === 0) return wholeFeature();
    const lengthCm = getLengthCm(feature);
    const intervals = (0, _stepSectionsMjs.resolveSections)(sectionsByTag, lengthCm);
    if (intervals.length === 0) return wholeFeature();
    const described = intervals.map((interval)=>({
            ...interval,
            descriptor: classify({
                ...scalarTags,
                ...interval.values
            })
        }));
    // Merge neighbours that render identically, so a tag change that doesn't
    // change the styling doesn't fragment the line into extra sliced styles.
    return (0, _stepSectionsMjs.mergeAdjacent)(described, (section)=>JSON.stringify(section.descriptor)).map((section)=>toStyles(section.descriptor, cached(sliceCache, feature, `${geometry.getRevision()}:${section.startCm}-${section.endCm}`, ()=>(0, _util.sliceOlLineByCm)(geometry, section.startCm, section.endCm)))).flat();
}

},{"@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../../../util":"4IC9E","./lrDecoding":"elFsF","./stepSections.mjs":"bZM8z","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bssof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneRestrictionInteractions", ()=>getHDLaneRestrictionInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdLaneRestriction = require("../style/hdLaneRestriction");
function getHDLaneRestrictionInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _hdLaneRestriction.getHDLaneRestrictionStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray()));
        else control.set("selectedFeatures", undefined);
    });
    const hoverSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.pointerMove),
        style: function(feature) {
            return (0, _hdLaneRestriction.getHDLaneRestrictionStyleHover)(feature);
        }
    });
    return [
        clickSelect,
        hoverSelect
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdLaneRestriction":"fX2Ql","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8bVY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneWidthStyleNormal", ()=>getHDLaneWidthStyleNormal);
parcelHelpers.export(exports, "getHDLaneWidthStyleClick", ()=>getHDLaneWidthStyleClick);
parcelHelpers.export(exports, "getHDLaneWidthStyleHover", ()=>getHDLaneWidthStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
var _default = require("./default");
var _linearStyling = require("./linearStyling");
var _d3ScaleChromatic = require("d3-scale-chromatic");
function getHDLaneWidthStyleNormal(feature, resolution) {
    return getHDLaneWidthColorStyle(feature, false, false, resolution);
}
function getHDLaneWidthStyleClick(feature, resolution) {
    return getHDLaneWidthColorStyle(feature, true, false, resolution);
}
function getHDLaneWidthStyleHover(feature, resolution) {
    return getHDLaneWidthColorStyle(feature, false, true, resolution);
}
function getHDLaneWidthColorStyle(feature, click, hover) {
    const tags = (0, _propertyExtraction.extractTags)(feature);
    if (tags.hdMap !== "lane_center_line" && tags.hdMap !== "lane_trajectory_line") return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "transparent",
                width: 0
            })
        })
    ];
    let width, backgroundColor, backgroundWidth;
    let orbisLaneWidth = (0, _propertyExtraction.getPropertyEndingWith)(feature, "width");
    if (orbisLaneWidth === undefined) orbisLaneWidth = (0, _propertyExtraction.getPropertyEndingWith)(feature, "width:linear");
    if (orbisLaneWidth === undefined) return (0, _default.getDefaultColorStyle)(feature, click, hover);
    else {
        if (click) backgroundColor = "orange";
        else backgroundColor = "black";
        if (hover || click) {
            width = 7;
            backgroundWidth = 10;
        } else {
            width = 5;
            backgroundWidth = 9;
        }
        const flowStyle = (0, _linearStyling.getLinearTagFlowStyle)(orbisLaneWidth, width, feature, (0, _d3ScaleChromatic.interpolatePuBuGn), "laneWidth");
        return [
            flowStyle,
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: backgroundColor,
                    width: backgroundWidth
                })
            })
        ];
    }
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","./default":"e6A2s","./linearStyling":"1P32G","d3-scale-chromatic":[["interpolatePuBuGn","4pJI5","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4pJI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"3Mhvi","../ramp.js":"cmbZB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dhU0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDLaneWidthInteractions", ()=>getHDLaneWidthInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdLaneWidth = require("../style/hdLaneWidth");
function getHDLaneWidthInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: (0, _hdLaneWidth.getHDLaneWidthStyleClick)
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: (0, _hdLaneWidth.getHDLaneWidthStyleHover)
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdLaneWidth":"8bVY4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bIHM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOsmLanesNormStyleNormal", ()=>getOsmLanesNormStyleNormal);
parcelHelpers.export(exports, "getOsmLanesNormStyleClick", ()=>getOsmLanesNormStyleClick);
parcelHelpers.export(exports, "getOsmLanesNormStyleHover", ()=>getOsmLanesNormStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
function getOsmLanesNormStyleNormal(feature) {
    return getOsmLanesNormColorStyle(feature);
}
function getOsmLanesNormStyleClick(feature) {
    return getOsmLanesNormColorStyle(feature, true, false);
}
function getOsmLanesNormStyleHover(feature) {
    return getOsmLanesNormColorStyle(feature, false, true);
}
function getOsmLanesNormColorStyle(feature, click = false, hover = false) {
    const tags = (0, _propertyExtraction.extractTags)(feature);
    if (tags.lanesNormMotorVehicle === undefined && tags.lanesNormMotorCar === undefined && tags.lanesNormHgv === undefined && tags.lanesNormPsv === undefined && tags.lanesNormBus === undefined && tags.lanesNormTaxi === undefined && tags.lanesNormHov === undefined) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "transparent",
                width: 0
            })
        })
    ];
    let color;
    let backgroundColor = "white";
    let width;
    let backgroundWidth;
    if (tags.lanesNormBus === "yes") {
        color = "maroon";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormHgv === "yes") {
        color = "purple";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormPsv === "yes") {
        color = "blue";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormTaxi === "yes") {
        color = "yellow";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormHov === "yes") {
        color = "orange";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormMotorCar === "yes") {
        color = "green";
        width = 4;
        backgroundWidth = 6;
    } else if (tags.lanesNormMotorVehicle !== undefined && tags.lanesNormMotorVehicle !== "yes") {
        color = "darkgrey";
        width = 4;
        backgroundWidth = 6;
    } else {
        color = "grey";
        width = 1;
        backgroundWidth = 2;
    }
    if (hover || click) {
        backgroundWidth = 6;
        return [
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: backgroundColor,
                    width: backgroundWidth
                })
            }),
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: color,
                    width: width
                })
            })
        ];
    }
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jevy1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOsmLanesNormInteractions", ()=>getOsmLanesNormInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _osmLanesNorm = require("../style/osmLanesNorm");
function getOsmLanesNormInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: (0, _osmLanesNorm.getOsmLanesNormStyleClick)
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: (0, _osmLanesNorm.getOsmLanesNormStyleHover)
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/osmLanesNorm":"bIHM4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2pw1E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getControlledAccessStyleNormal", ()=>getControlledAccessStyleNormal);
parcelHelpers.export(exports, "getControlledAccessStyleClick", ()=>getControlledAccessStyleClick);
parcelHelpers.export(exports, "getControlledAccessStyleHover", ()=>getControlledAccessStyleHover);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _node = require("./node");
function getControlledAccessStyleNormal(feature) {
    return getControlledAccessColorStyle(feature).concat((0, _node.getNodeStyleNormal)(feature));
}
function getControlledAccessStyleClick(feature) {
    return getControlledAccessColorStyle(feature, true, false).concat((0, _node.getNodeStyleClick)(feature));
}
function getControlledAccessStyleHover(feature) {
    return getControlledAccessColorStyle(feature, false, true).concat((0, _node.getNodeStyleHover)(feature));
}
function getControlledAccessColorStyle(feature, click, hover) {
    let color, width;
    const controlledAccess = findValueByKeyEndingWith(feature.getProperties(), "controlled_access");
    const highway = findValueByKeyEndingWith(feature.getProperties(), "highway");
    if (highway === undefined) {
        color = "black";
        width = 1;
    } else if (!(0, _supportedHighwayTypes.CONTROLLED_ACCESS_HIGHWAY_TYPES).includes(highway)) {
        color = "grey";
        width = 1;
    } else if (controlledAccess === "yes") {
        color = "#E5C95F"; // yellow
        width = 9;
    } else if (controlledAccess === "entrance_exit") {
        color = "#41A67E"; // green
        width = 9;
    } else if (controlledAccess === "connection") {
        color = "#05339C"; // blue
        width = 9;
    } else {
        color = "#abdbe3"; // light blue
        width = 1;
    }
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 3
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "#eab676",
                width: width * 2
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: width * 4
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width * 2
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}
function findValueByKeyEndingWith(obj, suffix) {
    const key = Object.keys(obj).find((key)=>key.endsWith(suffix));
    return obj[key];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","./node":"1eDKT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1oi5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getControlledAccessInteractions", ()=>getControlledAccessInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _controlledAccess = require("../style/controlledAccess");
function getControlledAccessInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _controlledAccess.getControlledAccessStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _controlledAccess.getControlledAccessStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/controlledAccess":"2pw1E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bPJbb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "crosslinkCoverageHandler", ()=>crosslinkCoverageHandler);
var _util = require("../../util");
const crosslinkCoverageHandler = (event)=>{
    const features = event.target.getFeatures();
    const featureById = new Map(features.map((f)=>[
            f.getId(),
            f
        ]));
    // memberId -> array of covered ranges; a `null` entry means "fully covered".
    const coverageById = new Map();
    // memberId -> ranges to draw red: the matching segment on THIS member when
    // the OTHER member of a shared relation overshoots its own length.
    const redRangesById = new Map();
    features.forEach((relation)=>{
        if (relation.get("type") !== "ORBIS_RELATION") return;
        relation.getKeys().forEach((key)=>{
            if (!(key.startsWith("relation-member-") && key.endsWith("-id"))) return;
            const memberId = relation.get(key);
            const role = relation.get(key.replace("-id", "-role"));
            const ranges = (0, _util.getRoleRangesCm)(role);
            const list = coverageById.get(memberId) || [];
            if (typeof role === "string" && role.includes("=") && ranges.length > 0) list.push(...ranges);
            else // Plain role (full way) or unparseable LR → treat as fully covered.
            list.push(null);
            coverageById.set(memberId, list);
        });
        // When a member's role runs past that member's own length the relation is
        // out-of-bounds (a data error). The user wants the error shown on the
        // PARTNER: road overshoots → flag the matching lane segment red, and vice
        // versa. For each range index where member A overshoots, mark every other
        // member B's matching section (paired by index, like the hover handler).
        const members = relation.getKeys().filter((key)=>key.startsWith("relation-member-") && key.endsWith("-id")).map((key)=>{
            const id = relation.get(key);
            return {
                id,
                ranges: (0, _util.getRoleRangesCm)(relation.get(key.replace("-id", "-role"))),
                feature: featureById.get(id)
            };
        });
        members.forEach((a)=>{
            const lengthCm = a.feature && a.feature.get("lengthCm");
            if (!(lengthCm > 0)) return;
            a.ranges.forEach((range, index)=>{
                if (!(Number.isFinite(range.endCm) && range.endCm > lengthCm)) return;
                members.forEach((b)=>{
                    if (b.id === a.id) return;
                    const list = redRangesById.get(b.id) || [];
                    list.push(...matchingRanges(b.ranges, index));
                    redRangesById.set(b.id, list);
                });
            });
        });
    });
    features.forEach((feature)=>{
        if (feature.get("type") === "ORBIS_RELATION") return;
        const uncovered = uncoveredRangesCm(coverageById.get(feature.getId()), feature.get("lengthCm"));
        const geometries = uncovered.map((range)=>(0, _util.sliceOlLineByCm)(feature.getGeometry(), range.startCm, range.endCm));
        feature.set("crosslinkUncoveredGeoms", geometries);
        const redRanges = redRangesById.get(feature.getId()) || [];
        const outOfBoundsGeoms = redRanges.map((range)=>(0, _util.sliceOlLineByCm)(feature.getGeometry(), range.startCm, range.endCm));
        feature.set("crosslinkOutOfBoundsGeoms", outOfBoundsGeoms);
    });
};
// The section(s) on one member that pair with range `index` of the partner —
// same index-based pairing the hover handler (CrosslinkLayerHandler) uses. A
// plain role (no decodable ranges) covers the whole way: [0, Infinity], which
// sliceOlLineByCm clamps to the geometry length.
function matchingRanges(ranges, index) {
    if (ranges.length === 0) return [
        {
            startCm: 0,
            endCm: Infinity
        }
    ];
    if (ranges.length === 1) return [
        ranges[0]
    ];
    if (index < ranges.length) return [
        ranges[index]
    ];
    return ranges; // counts don't line up → highlight all the partner's sections
}
// The complement of the covered ranges over [0, lengthCm].
function uncoveredRangesCm(coverage, lengthCm) {
    const total = lengthCm > 0 ? lengthCm : Infinity;
    if (coverage === undefined) return [
        {
            startCm: 0,
            endCm: total
        }
    ]; // referenced by nothing → all uncovered
    if (coverage.some((range)=>range === null)) return []; // fully covered
    const merged = [];
    coverage.map((range)=>({
            startCm: Math.max(0, range.startCm),
            endCm: Math.min(range.endCm, total)
        })).filter((range)=>range.endCm > range.startCm).sort((a, b)=>a.startCm - b.startCm).forEach((range)=>{
        const last = merged[merged.length - 1];
        if (last && range.startCm <= last.endCm) last.endCm = Math.max(last.endCm, range.endCm);
        else merged.push({
            ...range
        });
    });
    const gaps = [];
    let cursor = 0;
    merged.forEach((range)=>{
        if (range.startCm > cursor) gaps.push({
            startCm: cursor,
            endCm: range.startCm
        });
        cursor = Math.max(cursor, range.endCm);
    });
    if (cursor < total) gaps.push({
        startCm: cursor,
        endCm: total
    });
    return gaps;
}

},{"../../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gshhL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCaJInteractionsOrbisSD", ()=>getCaJInteractionsOrbisSD);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _curvatureAtJunction = require("../style/curvatureAtJunction");
function getCurvatureInteractions(clickStyle, hoverStyle) {
    return function(layer, control) {
        const clickSelect = new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.click),
            style: function(feature, resolution) {
                return clickStyle(feature, resolution);
            }
        });
        clickSelect.on("select", function(e) {
            if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
            else control.set("selectedFeatures", undefined);
        });
        const hoverSelect = new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature, resolution) {
                return hoverStyle(feature, resolution);
            }
        });
        return [
            clickSelect,
            hoverSelect
        ];
    };
}
function getCaJInteractionsOrbisSD() {
    return getCurvatureInteractions((0, _curvatureAtJunction.getCaJStyleClickOrbisSD), (0, _curvatureAtJunction.getCaJStyleHoverOrbisSD));
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/curvatureAtJunction":"dIuFs","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"blYI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDLaneRestrictionStyleNormal", ()=>getSDLaneRestrictionStyleNormal);
parcelHelpers.export(exports, "getSDLaneRestrictionHovStyleNormal", ()=>getSDLaneRestrictionHovStyleNormal);
parcelHelpers.export(exports, "getSDLaneRestrictionStyleClick", ()=>getSDLaneRestrictionStyleClick);
parcelHelpers.export(exports, "getSDLaneRestrictionStyleHover", ()=>getSDLaneRestrictionStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
var _stepSectionStyle = require("./util/stepSectionStyle");
function getSDLaneRestrictionStyleNormal(feature) {
    return getSDLaneRestrictionColorStyle(feature);
}
function getSDLaneRestrictionHovStyleNormal(feature) {
    return getSDLaneRestrictionHovColorStyle(feature);
}
function getSDLaneRestrictionStyleClick(feature) {
    return getSDLaneRestrictionHovColorStyle(feature, true, false);
}
function getSDLaneRestrictionStyleHover(feature) {
    return getSDLaneRestrictionHovColorStyle(feature, false, true);
}
// Shared shell for both SD families: normal draws the classified stroke,
// hover puts it on a white casing, click puts an orange core on it.
function toSDStyles(descriptor, geometry, click, hover) {
    if (click) return [
        new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: descriptor.color,
                width: 6
            })
        }),
        new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: 4
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: 8
            })
        }),
        new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: descriptor.color,
                width: 4
            })
        })
    ];
    return [
        new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: descriptor.color,
                width: descriptor.width
            })
        })
    ];
}
function classifySDLaneRestrictionHov(tags) {
    if (tags.rm_hovLanes) return {
        color: "orange",
        width: 8
    };
    return {
        color: "black",
        width: 2
    };
}
function getSDLaneRestrictionHovColorStyle(feature, click = false, hover = false) {
    return (0, _stepSectionStyle.styleBySection)(feature, (0, _propertyExtraction.extractTags)(feature), classifySDLaneRestrictionHov, (descriptor, geometry)=>toSDStyles(descriptor, geometry, click, hover));
}
function isOnlyBusAllowed(tags) {
    if (tags.rm_vehicleAccessHgv && tags.rm_vehicleAccessHgv.includes("no") && tags.rm_vehicleAccessMotorcar && tags.rm_vehicleAccessMotorcar.includes("no") && tags.rm_vehicleAccessTaxi && tags.rm_vehicleAccessTaxi.includes("no") && !tags.rm_vehicleAccessBus) return true;
    return false;
}
function isOnlyTaxiAndBusAllowed(tags) {
    if (tags.rm_vehicleAccessHgv && tags.rm_vehicleAccessHgv.includes("no") && tags.rm_vehicleAccessMotorcar && tags.rm_vehicleAccessMotorcar.includes("no") && !tags.rm_vehicleAccessBus && !tags.rm_vehicleAccessTaxi) return true;
    return false;
}
function isOnlyTaxiAllowed(tags) {
    if (tags.rm_vehicleAccessHgv && tags.rm_vehicleAccessHgv.includes("no") && tags.rm_vehicleAccessMotorcar && tags.rm_vehicleAccessMotorcar.includes("no") && tags.rm_vehicleAccessBus && tags.rm_vehicleAccessBus.includes("no") && !tags.rm_vehicleAccessTaxi) return true;
    return false;
}
function isHgvNotAllowed(tags) {
    if (tags.rm_vehicleAccessHgv && tags.rm_vehicleAccessHgv.includes("no") && !tags.rm_vehicleAccessTaxi && !tags.rm_vehicleAccessMotorcar && !tags.rm_vehicleAccessBus) return true;
    return false;
}
function isFullyClosed(tags) {
    if (tags.rm_vehicleAccessHgv && tags.rm_vehicleAccessHgv.includes("no") && tags.rm_vehicleAccessTaxi && tags.rm_vehicleAccessTaxi.includes("no") && tags.rm_vehicleAccessBus && tags.rm_vehicleAccessBus.includes("no") && tags.rm_vehicleAccessMotorcar && tags.rm_vehicleAccessMotorcar.includes("no")) return true;
    return false;
}
// bus ==> maroon, hgv ==> purple, psv ==> blue, taxi ==> yellow, hov ==> orange,
// motor_vehicle restriction ==> darkgrey, else grey
//
// The predicates read scalar values: a step-encoded access tag has already been
// resolved by styleBySection() to the value covering the section being drawn.
// That matters here — `"0-1000#no;5000-7000#yes".includes("no")` used to hold
// for the whole feature and painted the entire lane as restricted.
function classifySDLaneRestriction(tags) {
    if (isOnlyBusAllowed(tags)) return {
        color: "maroon",
        width: 8
    };
    if (isOnlyTaxiAndBusAllowed(tags)) return {
        color: "blue",
        width: 8
    };
    if (isOnlyTaxiAllowed(tags)) return {
        color: "yellow",
        width: 8
    };
    if (isHgvNotAllowed(tags)) return {
        color: "purple",
        width: 8
    };
    if (isFullyClosed(tags)) return {
        color: "darkgrey",
        width: 8
    };
    return {
        color: "black",
        width: 2
    };
}
function getSDLaneRestrictionColorStyle(feature, click = false, hover = false) {
    return (0, _stepSectionStyle.styleBySection)(feature, (0, _propertyExtraction.extractTags)(feature), classifySDLaneRestriction, (descriptor, geometry)=>toSDStyles(descriptor, geometry, click, hover));
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","./util/stepSectionStyle":"8hjKE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fsTm2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDLaneRestrictionInteractions", ()=>getSDLaneRestrictionInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _sdLaneRestriction = require("../style/sdLaneRestriction");
function getSDLaneRestrictionInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _sdLaneRestriction.getSDLaneRestrictionStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray()));
        else control.set("selectedFeatures", undefined);
    });
    const hoverSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.pointerMove),
        style: function(feature) {
            return (0, _sdLaneRestriction.getSDLaneRestrictionStyleHover)(feature);
        }
    });
    return [
        clickSelect,
        hoverSelect
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/sdLaneRestriction":"blYI9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kDeFr":[function(require,module,exports,__globalThis) {
// src/config/ProductAndControl.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Builds the service + ProductControl and inserts the drawer as a full-width sidebar section just above `target` (.vector-feature) in #controls-left. */ parcelHelpers.export(exports, "addProductControl", ()=>addProductControl);
var _bindingReportService = require("../services/BindingReportService");
var _productControl = require("../controls/ProductControl");
function addProductControl(map, target) {
    const service = new (0, _bindingReportService.HttpBindingReportService)("/binding-reports");
    const control = new (0, _productControl.ProductControl)({
        service
    });
    map.addControl(control);
    // Place the drawer as a full-width sidebar section directly above the layer
    // area — a sibling of `target` (.vector-feature) in #controls-left — so its
    // grey separator is flush and end-to-end like the other sidebar sections,
    // not an inset card+divider inside the padded .vector-feature.
    target.parentNode.insertBefore(control.element, target);
    return control;
}

},{"../services/BindingReportService":"6IKX6","../controls/ProductControl":"co5mC","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6IKX6":[function(require,module,exports,__globalThis) {
// src/services/BindingReportService.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Reads binding sync-metric reports from a same-origin base URL.
 * In prod, BINDING_REPORTS_URL points at the APIM proxy (/binding-reports)
 * that fronts the orbis-binding-sync-reports GitHub repo. In dev it points
 * at a static fixture under /binding-reports.
 *
 * This is the only place that knows the report wire format. To migrate to the
 * PRO GetProductReleaseInfo API later, replace this class (same public methods).
 */ parcelHelpers.export(exports, "HttpBindingReportService", ()=>HttpBindingReportService);
var _bindingProducts = require("../data/bindingProducts");
class HttpBindingReportService {
    /** @param {string} baseUrl e.g. "/binding-reports" */ constructor(baseUrl){
        this._baseUrl = (baseUrl || "").replace(/\/$/, "");
        this._index = null; // cached reports.json
    }
    /** Fetch (or re-fetch) reports.json. Always re-fetches so the dropdown stays fresh. */ async refreshIndex() {
        const res = await fetch(`${this._baseUrl}/reports.json`, {
            cache: "no-store"
        });
        if (!res.ok) throw new Error(`reports.json ${res.status} ${res.statusText}`);
        this._index = await res.json();
        return this._index;
    }
    /** @returns {Array<{code:string, displayName:string}>} allowed products, sorted by name. */ listProducts() {
        if (!this._index) return [];
        return Object.keys(this._index).filter((0, _bindingProducts.isProductAllowed)).map((code)=>({
                code,
                displayName: (0, _bindingProducts.productDisplayName)(code)
            })).sort((a, b)=>a.displayName.localeCompare(b.displayName));
    }
    /**
   * @returns {Array<{name:string, reportPath:string}>}
   * versions for a product, newest first.
   */ listVersions(scope) {
        if (!this._index || !this._index[scope]) return [];
        const all = [];
        for (const year of Object.keys(this._index[scope]))for (const r of this._index[scope][year])all.push({
            name: r.name,
            reportPath: r.report_path
        });
        // names sort lexicographically newest-last; reverse for newest-first.
        return all.sort((a, b)=>a.name < b.name ? 1 : a.name > b.name ? -1 : 0);
    }
    /**
   * Fetch a version's report and flatten every bound revision into a Map.
   * Includes parents (e.g. 6 / 29351), their children, and independentLayers.
   * @returns {Promise<Map<number, number>>} layerId -> revisionId
   */ async getProductMap(reportPath) {
        const res = await fetch(`${this._baseUrl}/${reportPath}`, {
            cache: "no-store"
        });
        if (!res.ok) throw new Error(`${reportPath} ${res.status} ${res.statusText}`);
        const report = await res.json();
        const map = new Map();
        const add = (node)=>{
            const v = node && node.boundVersion && node.boundVersion.version;
            if (v && typeof v.layerId === "number" && typeof v.revisionId === "number") map.set(v.layerId, v.revisionId);
        };
        for (const parent of report.parents || []){
            add(parent);
            for (const child of parent.children || [])add(child);
        }
        for (const ind of report.independentLayers || [])add(ind);
        return map;
    }
}

},{"../data/bindingProducts":"9O3gX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9O3gX":[function(require,module,exports,__globalThis) {
// src/data/bindingProducts.js
// Scope code (reports.json key / filename prefix) -> human display name.
// Source: the sync-metric-reports site's index.js productNameMapping.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productNameMapping", ()=>productNameMapping);
parcelHelpers.export(exports, "PRODUCT_PREFIX_ALLOWLIST", ()=>PRODUCT_PREFIX_ALLOWLIST);
parcelHelpers.export(exports, "isProductAllowed", ()=>isProductAllowed);
parcelHelpers.export(exports, "productDisplayName", ()=>productDisplayName);
const productNameMapping = {
    MB_WRL: "Orbis Mini-Binding",
    OA_WRL: "Orbis AdHoc",
    OA_KOR: "Orbis AdHoc Korea",
    OB_WRL: "Orbis Bifrost",
    OF_WRL: "Orbis Everflow",
    OLM_WRL: "Orbis LaneModel",
    ON_WRL: "Orbis NexVentura",
    ON_KOR: "Orbis NexVentura KOR",
    ONA_WRL: "Orbis NexVentura ADAS",
    ONAKOR_KOR: "Orbis NexVentura ADAS KOR",
    OV_WRL: "Orbis Ventura",
    OT_GLOBAL: "Overture Transportation",
    TTMPO_WRL: "Tempo"
};
const PRODUCT_PREFIX_ALLOWLIST = [];
function isProductAllowed(scope) {
    // Only products whose display name contains "Orbis" appear in the picker.
    if (!/orbis/i.test(productDisplayName(scope))) return false;
    return PRODUCT_PREFIX_ALLOWLIST.length === 0 || PRODUCT_PREFIX_ALLOWLIST.includes(scope);
}
function productDisplayName(scope) {
    return productNameMapping[scope] || scope;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"co5mC":[function(require,module,exports,__globalThis) {
// src/controls/ProductControl.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * "Orbis product" drawer. Lets the user pick a product + version; on select it
 * builds a layerId->revisionId map via the service and fans it out to every
 * registered RevisionControl. Inserted as a full-width section in #controls-left, just above the layer area.
 */ parcelHelpers.export(exports, "ProductControl", ()=>ProductControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _urlstateManager = require("../state/URLStateManager");
class ProductControl extends (0, _controlDefault.default) {
    /** @param {{ service: object }} options */ constructor(options = {}){
        const details = document.createElement("details");
        details.className = "product-drawer";
        details.open = false;
        super({
            element: details,
            target: undefined
        });
        this._service = options.service;
        this._map = null; // current layerId->rev map
        const summary = document.createElement("summary");
        summary.textContent = "Orbis product";
        details.appendChild(summary);
        const body = document.createElement("div");
        body.className = "product-body";
        details.appendChild(body);
        this._summaryEl = summary;
        const selects = document.createElement("div");
        selects.className = "product-selects";
        body.appendChild(selects);
        this._productSel = this._buildSelect(selects, "Pick a product");
        this._versionSel = this._buildSelect(selects, "Pick a report");
        this._versionSel.disabled = true;
        this._status = document.createElement("div");
        this._status.className = "product-status";
        body.appendChild(this._status);
        this._undoBar = document.createElement("div");
        this._undoBar.className = "product-undo";
        this._undoBar.setAttribute("role", "status");
        this._undoBar.hidden = true;
        body.appendChild(this._undoBar);
        this._bulk = document.createElement("div");
        this._bulk.className = "product-bulk";
        this._bulk.hidden = true;
        body.appendChild(this._bulk);
        this._buildBulk();
        // Refresh index when the product dropdown is opened/focused.
        this._productSel.addEventListener("mousedown", ()=>this._loadIndex());
        this._productSel.addEventListener("focus", ()=>this._loadIndex());
        this._productSel.addEventListener("change", ()=>this._onProductChange());
        this._versionSel.addEventListener("change", ()=>this._onVersionChange());
        this._loadIndex();
        this._restoreFromUrl();
    }
    async _restoreFromUrl() {
        const initial = (0, _urlstateManager.getInitialProductState)();
        if (!initial) return;
        // Reload WITH a product in the URL -> open the drawer.
        this.element.open = true;
        await this._loadIndex();
        this._productSel.value = initial.scope;
        this._onProductChange();
        // version option values are reportPaths; find the one whose name matches
        const versions = this._service.listVersions(initial.scope);
        const match = versions.find((v)=>v.name === initial.version);
        if (match) {
            this._versionSel.value = match.reportPath;
            // Restore: derive labels from the URL revision values, never overwrite them.
            await this._onVersionChange(true);
        }
    }
    _buildSelect(parent, labelText) {
        const span = document.createElement("span");
        const label = document.createElement("label");
        label.textContent = labelText;
        const sel = document.createElement("select");
        label.htmlFor = sel.id = `product-sel-${labelText.replace(/\s+/g, "-")}`;
        span.appendChild(label);
        span.appendChild(sel);
        parent.appendChild(span);
        return sel;
    }
    /** Coalesce concurrent calls onto one cached in-flight promise. */ _loadIndex() {
        if (this._indexPromise) return this._indexPromise;
        this._indexPromise = (async ()=>{
            const prev = this._productSel.value;
            // Safari's native <select> popup snapshots its options when it opens and
            // ignores later async option changes — so the refresh-on-open must not
            // wipe an already-populated dropdown to "Loading…", nor replace its
            // options when nothing changed, or it stays stuck on the stale snapshot.
            // Show the placeholder only on the first (empty) load; else refresh quietly.
            const hasProducts = this._productSel.options.length > 1;
            if (!hasProducts) this._setOptions(this._productSel, [
                {
                    value: "",
                    label: "Loading products\u2026"
                }
            ]);
            try {
                await this._service.refreshIndex();
                const products = this._service.listProducts();
                const opts = [
                    {
                        value: "",
                        label: "\u2014 Select a product \u2014"
                    }
                ].concat(products.map((p)=>({
                        value: p.code,
                        label: p.displayName
                    })));
                const current = Array.from(this._productSel.options).map((o)=>o.value);
                const changed = current.length !== opts.length || opts.some((o, i)=>o.value !== current[i]);
                if (changed) {
                    this._setOptions(this._productSel, opts);
                    if (prev) this._productSel.value = prev;
                }
                this._status.textContent = "";
            } catch (e) {
                this._setOptions(this._productSel, [
                    {
                        value: "",
                        label: "\u2014"
                    }
                ]);
                this._status.textContent = `Couldn't load products \u{2014} ${e.message}`;
            }
        })().finally(()=>{
            this._indexPromise = null;
        });
        return this._indexPromise;
    }
    _onProductChange() {
        const scope = this._productSel.value;
        if (!scope) {
            this._versionSel.disabled = true;
            this._setOptions(this._versionSel, [
                {
                    value: "",
                    label: "Select a product first"
                }
            ]);
            return;
        }
        const versions = this._service.listVersions(scope);
        const opts = [
            {
                value: "",
                label: "\u2014 Select a version \u2014"
            }
        ].concat(versions.map((v)=>({
                value: v.reportPath,
                label: v.name
            })));
        this._setOptions(this._versionSel, opts);
        this._versionSel.disabled = false;
    }
    /**
   * @param {boolean} fromUrl URL restore: derive labels only, do not overwrite
   *   restored revision values (passed down to each RevisionControl).
   */ async _onVersionChange(fromUrl = false) {
        const reportPath = this._versionSel.value;
        const scope = this._productSel.value;
        if (!reportPath) return;
        this._status.textContent = "Loading version\u2026";
        try {
            this._map = await this._service.getProductMap(reportPath);
            const label = this._productSel.options[this._productSel.selectedIndex].text;
            const match = this._service.listVersions(scope).find((v)=>v.reportPath === reportPath);
            const versionName = match ? match.name : reportPath;
            this._appliedVersionName = versionName; // used in the undo details header
            this._applyToAll(label, fromUrl);
            this._summaryEl.textContent = `Orbis product \u{2014} ${label} \xb7 ${versionName}`;
            (0, _urlstateManager.setProductState)(scope, versionName);
            this._bulk.hidden = false;
            this._status.textContent = "";
        } catch (e) {
            this._status.textContent = `Couldn't load version \u{2014} ${e.message}`;
        }
    }
    /** Fan the map out to all RevisionControls; show Undo for rows actually flipped. */ _applyToAll(productLabel, fromUrl = false) {
        let rows = [];
        for (const { control } of (0, _urlstateManager.getRevisionControls)()){
            control.setProductMap(this._map, productLabel, fromUrl);
            rows = rows.concat(control.getProductRows());
        }
        // Dedup by layerId — shared parent layers (e.g. 6, 29351) appear in many
        // per-layer pickers; collapse to one row and count each layer once.
        const byLayer = new Map();
        for (const r of rows)byLayer.set(r.layerId, r.revision);
        const deduped = [
            ...byLayer
        ].map(([layerId, revision])=>({
                layerId,
                revision
            })).sort((a, b)=>a.layerId - b.layerId);
        this._showUndo(deduped.length, deduped, this._appliedVersionName);
    }
    _showUndo(changed, rows = [], versionName = "") {
        if (!changed) {
            this._undoBar.hidden = true;
            return;
        }
        this._undoBar.innerHTML = "";
        this._undoBar.append(`${changed} layer(s) switched to product revisions. `);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = "Undo";
        btn.addEventListener("click", ()=>this._doUndo());
        this._undoBar.appendChild(btn);
        if (rows.length) this._undoBar.appendChild(this._buildUndoDetails(rows, versionName));
        this._undoBar.hidden = false;
    }
    /** Inline <details> listing the switched layers as `layerId:revisionId`. */ _buildUndoDetails(rows, versionName) {
        const lines = rows.map((r)=>`${r.layerId}:${r.revision}`);
        const details = document.createElement("details");
        details.className = "product-undo-details";
        const summary = document.createElement("summary");
        summary.textContent = "Show details";
        details.appendChild(summary);
        const head = document.createElement("div");
        head.className = "product-undo-details-head";
        const scope = this._productSel.value;
        const label = scope ? this._productSel.options[this._productSel.selectedIndex].text : "product";
        const caption = document.createElement("span");
        caption.className = "product-undo-details-caption";
        caption.textContent = versionName ? `${label} \xb7 ${versionName}` : label;
        const copyBtn = document.createElement("button");
        copyBtn.type = "button";
        copyBtn.textContent = "Copy";
        copyBtn.addEventListener("click", ()=>{
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(lines.join("\n")).then(()=>{
                copyBtn.textContent = "Copied";
                setTimeout(()=>copyBtn.textContent = "Copy", 1200);
            });
        });
        head.appendChild(caption);
        head.appendChild(copyBtn);
        details.appendChild(head);
        const list = document.createElement("div");
        list.className = "product-undo-details-list";
        for (const line of lines){
            const row = document.createElement("div");
            row.textContent = line;
            list.appendChild(row);
        }
        details.appendChild(list);
        return details;
    }
    _doUndo() {
        // Revert only the applied report: layers back to latest, keep the product
        // selected and its version list, reset only the version dropdown.
        for (const { control } of (0, _urlstateManager.getRevisionControls)())control.clearProduct();
        this._undoBar.hidden = true;
        this._map = null;
        this._bulk.hidden = true;
        this._versionSel.value = "";
        const scope = this._productSel.value;
        const label = scope ? this._productSel.options[this._productSel.selectedIndex].text : null;
        this._summaryEl.textContent = label ? `Orbis product \u{2014} ${label}` : "Orbis product";
        (0, _urlstateManager.setProductState)(scope || null, null);
    }
    _buildBulk() {
        const toProduct = document.createElement("button");
        toProduct.type = "button";
        toProduct.textContent = "All to product";
        toProduct.addEventListener("click", ()=>{
            for (const { control } of (0, _urlstateManager.getRevisionControls)())control.bulkSetSource("product");
        });
        const toLatest = document.createElement("button");
        toLatest.type = "button";
        toLatest.textContent = "All to latest";
        toLatest.addEventListener("click", ()=>{
            for (const { control } of (0, _urlstateManager.getRevisionControls)())control.bulkSetSource("latest");
        });
        this._bulk.appendChild(toProduct);
        this._bulk.appendChild(toLatest);
    }
    _setOptions(sel, opts) {
        sel.innerHTML = "";
        for (const o of opts){
            const opt = document.createElement("option");
            opt.value = o.value;
            opt.textContent = o.label;
            sel.appendChild(opt);
        }
    }
}

},{"ol/control/Control":"8KSMn","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fqVwh":[function(require,module,exports,__globalThis) {
/**
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {boolean} xhrWithCredentials The value of withCredentials to set.
 * @param {Object<string,string|Function>} requestHeaders header, value pairs
 * @param {import("./format/Feature.js").default} format Feature format.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @param {function(Array<import("./Feature.js").default>, import("./proj/Projection.js").default): void} success Success
 *      Function called with the loaded features and optionally with the data projection.
 * @param {function(): void} failure Failure
 *      Function called when loading failed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadFeaturesXhr", ()=>loadFeaturesXhr);
/**
 * Create an XHR feature loader for a `url` and `format`. The feature loader
 * loads features (with XHR), parses the features, and adds them to the
 * vector source.
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {import("./format/Feature.js").default} format Feature format.
 * @param {boolean} xhrWithCredentials The value of withCredentials to set.
 * @param {Object<string,string|Function>} requestHeaders header, value pairs
 * @return {FeatureLoader} The feature loader.
 * @api
 */ parcelHelpers.export(exports, "xhr", ()=>xhr);
function loadFeaturesXhr(url, xhrWithCredentials, requestHeaders, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
    for (const [header, value] of Object.entries(requestHeaders))if (value !== undefined) xhr.setRequestHeader(header, typeof value === "function" ? value() : value);
    if (format.getType() == "arraybuffer") xhr.responseType = "arraybuffer";
    xhr.withCredentials = xhrWithCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function() {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            /** @type {Document|Node|Object|string|undefined} */ let source;
            if (type == "json" || type == "text") source = xhr.responseText;
            else if (type == "xml") {
                source = xhr.responseXML;
                if (!source) source = new DOMParser().parseFromString(xhr.responseText, "application/xml");
            } else if (type == "arraybuffer") source = /** @type {ArrayBuffer} */ xhr.response;
            if (source) success(/** @type {Array<import("./Feature.js").default>} */ format.readFeatures(source, {
                extent: extent,
                featureProjection: projection
            }), format.readProjection(source));
            else {
                failure(`HTTP ${xhr.status}: empty response`);
                failure(`HTTP ${xhr.status}: empty response`);
            }
        } else failure(`HTTP ${xhr.status} ${xhr.statusText}`.trim());
    };
    /**
   * @private
   */ xhr.onerror = ()=>failure("Network error");
    xhr.send();
}
function xhr(url, format, xhrWithCredentials, requestHeaders, onError) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<import("./Feature.js").default>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   */ return function(extent, resolution, projection, success, failure) {
        const source = /** @type {import("./source/Vector").default} */ this;
        loadFeaturesXhr(url, xhrWithCredentials, requestHeaders, format, extent, resolution, projection, function(features) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, failure ? (reason)=>{
            if (onError) onError(reason);
            failure();
        } : undefined);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},["fYvWu"], "fYvWu", "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.a84e4ada.js.map
